import React, { useState, useEffect, useMemo, useRef } from 'react';
import { parseCustomDate } from '../../../utils/dateUtils';
import axios from 'axios';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  FormControl, InputLabel, Select, MenuItem, OutlinedInput,
  Paper, Box, Typography, Avatar, Chip, Divider, Stack, List, ListItem, ListItemText, Portal, Popper, Skeleton,
  Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, CircularProgress
} from '@mui/material';
import { DatePicker } from 'antd';
import dayjs from 'dayjs';
import './TaskModule.css';
import Swal from 'sweetalert2';
import DynamicCalendar from '../../../components/DynamicCalendar/DynamicCalendar';
import { getInitials, getAvatarColorScheme } from '../../../utils/helpers';
import { LeadDetails as CommonLeadDetails } from '../../../components/common/LeadDetails/LeadDetails';
import TaskFilterationActions from './TaskFilterationActions';
import TaskHeader from './TaskHeader';
import LeadActionOperation from '../../../common/LeadActionOperation/LeadActionOperation';
import Panels, { AppointmentTaskDetailPanel } from '../../../components/common/Panels/Panels';
import GridMainPanelLayout from '../../../components/common/Panels/GridMainPanelLayout';
import TaskListWrapper from './task/list/TaskListWrapper';
import PremiumModuleCards from './common/PremiumModuleCards';
import { MassEntityActionMenu, MassOperationDrawer, MassOperationPanel } from '../../../components/common/MassOperation/MassOperation';
import { AnimatePresence } from 'framer-motion';
import EntityEdit from '../../../components/common/EntityEdit/EntityEdit';
import Loader from '../../../components/Loader/Loader';
import Alert from '../../../common/Alerts/Alert';
import nodata from '../../../assets/nodata.gif';
import {
  PhoneCall, Mail, MessageSquare, Mic,
  FileText, Upload, ClipboardCheck,
  Calendar, Percent, FileEdit, Settings,
  ArrowUp, ArrowDown, User, Paperclip, X,
  Filter, Plus
} from 'lucide-react';
import usePermissions from '../../Master_Settings/usePermissions';
import useFieldMasking from '../../Master_Settings/useFieldMasking';
import API_ENDPOINTS from '../../../config/apiEndpoints';
import ScoreCard from '../../../components/common/ScoreCard/ScoreCard';

const API_BASE_SERVICES = (process.env.REACT_APP_SERVICES_AZURE_BASEURL || '').replace(/\/$/, '');
const WCF_BASE = (process.env.REACT_APP_WCF_API_BASE_URL || '').replace(/\/$/, '');
const API_BASE_WCF = (process.env.REACT_APP_WCF_API_BASE_URL || '').replace(/\/$/, '');
const NEW_ADDED_BASE_URL = (process.env.REACT_APP_SERVICES_API_BASE_URL || '').replace(/\/$/, '');
const API_BASE = (process.env.REACT_APP_SERVICES_AZURE_BASEURL || '').replace(/\/$/, '');
const NEWV3_BASE_URL = (process.env.REACT_APP_SERVICES_API_BASE_URL || '').replace(/\/$/, '');

const GETUSERSAPI = `${NEWV3_BASE_URL}${API_ENDPOINTS.TASKS.GET_TASK_HISTORY_FOR_DETAILS_EDIT}`;
const DeleteTask = `${API_BASE_SERVICES}/${API_ENDPOINTS.TASKS.GET_USER_LIST_FORTASK}`;
const Task_type = `${API_BASE_SERVICES}${API_ENDPOINTS.TASKS.GET_SALES_ACTIVITY_TYPE}`;
const FOR_OWNER = `${API_BASE_SERVICES}${API_ENDPOINTS.APPOINTMENTS.GET_USER_HIRERARCHY_LIST}`;
const ADD_TASK_URL = `${API_BASE_SERVICES}/${API_ENDPOINTS.TASKS.INSERT_NEW_TASK_OR_APPOINTMENT}`;
const Related_TO_Suggestion = `${API_BASE_SERVICES}/${API_ENDPOINTS.TASKS.RELATED_TO_SUGGETION}`;
const Collabrator_API = `${WCF_BASE}${API_ENDPOINTS.APPOINTMENTS.GET_USERLIST_PHYSICALAPP_VIEW}`;
const Mass_Update_API = `${WCF_BASE}${API_ENDPOINTS.APPOINTMENTS.MASS_UPDATE}`;
const SCORECARD_URL = `${NEWV3_BASE_URL}${API_ENDPOINTS.FOLLOWUPS.SCORE_CARD_DETAILS}`;
const GET_TASK_COMMENTS = `${NEW_ADDED_BASE_URL}${API_ENDPOINTS.COMMON.GET_COMMENTS}`;
const GET_TASK_DETAILS = `${NEWV3_BASE_URL}${API_ENDPOINTS.APPOINTMENTS.GET_TASK_DETAILS_BYID}`;
const Delete_Task = `${API_BASE_SERVICES}${API_ENDPOINTS.TASKS.DELETE_TASK}`;
const Get_Outcome_List = `${API_BASE_SERVICES}${API_ENDPOINTS.TASKS.GET_OUTCOME_LIST}`;
const Save_Mark_As_Complete = `${API_BASE_SERVICES}${API_ENDPOINTS.TASKS.SAVE_MARK_AS_COMPLETE}`;
const Add_Comment = `${API_BASE_SERVICES}${API_ENDPOINTS.TASKS.ADD_COMMENT}`;
const Get_Task_Details = `${NEWV3_BASE_URL}${API_ENDPOINTS.APPOINTMENTS.GET_TASK_DETAILS_BYID}`;
const Collabrator = `${NEWV3_BASE_URL}${API_ENDPOINTS.INVOICE.GET_OWNER_DROPDOWN}`;
const Export_Doc_URL = `${API_BASE_SERVICES}${API_ENDPOINTS.TASKS.EXPORT_DOC}`;
const Mass_Update = `${API_BASE}${API_ENDPOINTS.TASKS.MASS_UPDATE_SAVE}`;

const cleanTaskTitle = (t) => {
  if (!t) return "No Title";
  return String(t).trim() || "Task";
};

const TaskModule = () => {
  const { permissions } = usePermissions('PAG10034');
  const { maskObject, isHiddenField } = useFieldMasking('PAG10372#PAG10034');
  const crmOperationPerms = useMemo(() => {
    if (!permissions || !Array.isArray(permissions)) return null;
    return permissions.find(p => p.ModuleCode?.includes('PAG10034')) || {};
  }, [permissions]);

  const location = useLocation();
  const navigate = useNavigate();
  // API Integration
  const [tasks, setTasks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isInitialLoad, setIsInitialLoad] = useState(true);
  const [totalRecords, setTotalRecords] = useState(0);
  const [customSearchId, setCustomSearchId] = useState(0);
  const [viewingDetailTask, setViewingDetailTask] = useState(null);
  const [activeMeatball, setActiveMeatball] = useState(null);
  const [activeSettingsMenu, setActiveSettingsMenu] = useState(null);
  const [detailMode, setDetailMode] = useState('view'); // 'view', 'followup', 'add-deal'
  const [isCustomDownloadOpen, setIsCustomDownloadOpen] = useState(false);
  const [customExportFields, setCustomExportFields] = useState([]);
  const [customSettings, setCustomSettings] = useState([]);
  const [selectedExportFields, setSelectedExportFields] = useState([]);
  const [selectedCustomSetting, setSelectedCustomSetting] = useState('');
  const [exportSettingName, setExportSettingName] = useState('');
  const [isDownloading, setIsDownloading] = useState(false);
  const [fieldSearchTerm, setFieldSearchTerm] = useState('');
  const [searchTerm, setSearchTerm] = useState('');
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState('');
  const [viewingLeadId, setViewingLeadId] = useState(null);
  const [editingEntityInTask, setEditingEntityInTask] = useState(null);
  const [initialEditTaskData, setInitialEditTaskData] = useState(null);
  const [dashboardFilter, setDashboardFilter] = useState(location.state?.dashboardFilter || '');
  const [dashboardFilterLabel, setDashboardFilterLabel] = useState(location.state?.filterLabel || '');

  // Add Task Modal State
  const [showAddTaskModal, setShowAddTaskModal] = useState(false);
  const [addTaskData, setAddTaskData] = useState({
    Title: `NewTask_${new Date().toISOString().replace(/[-:T.Z]/g, '').slice(0, 14)}`,
    Description: '',
    TaskType: '7',
    DueDate: new Date().toISOString().split('T')[0],
    DueTime: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false }),
    Owner: '34594',
    Collaborators: '',
    SendNotification: true
  });

  const [taskTypeOptions, setTaskTypeOptions] = useState([]);
  const [ownerOptions, setOwnerOptions] = useState([]);
  const [collaboratorOptions, setCollaboratorOptions] = useState([]);
  const [isSubmittingTask, setIsSubmittingTask] = useState(false);

  // Related To autocomplete state
  const [relatedSearch, setRelatedSearch] = useState('');
  const [relatedSuggestions, setRelatedSuggestions] = useState([]);
  const [showRelatedDropdown, setShowRelatedDropdown] = useState(false);
  const [relatedSelected, setRelatedSelected] = useState(null);
  const relatedTimerRef = useRef(null);
  const relatedRef = useRef(null);

  // Comment Modal State
  const [showCommentModal, setShowCommentModal] = useState(false);
  const [commentText, setCommentText] = useState('');
  const [commentFile, setCommentFile] = useState(null);
  const [commentFileName, setCommentFileName] = useState('');
  const [taskForComment, setTaskForComment] = useState(null);
  const [isSavingComment, setIsSavingComment] = useState(false);


  // Outcome Modal State
  const [showOutcomeModal, setShowOutcomeModal] = useState(false);
  const [outcomeData, setOutcomeData] = useState({ outcomeId: '', remarks: '' });
  const [taskForOutcome, setTaskForOutcome] = useState(null);

  const outcomeOptions = [
    { Id: 931, Text: "Closed" },
    { Id: 930, Text: "pending" },
    { Id: 929, Text: "Waiting on customer" },
    { Id: 928, Text: "under process" },
    { Id: 927, Text: "waiting" }
  ];

  // Mass Update State
  const [isAllSelectedAcrossPages, setIsAllSelectedAcrossPages] = useState(false);
  const [allIds, setAllIds] = useState([]);
  const [rowSelection, setRowSelection] = useState({});
  const selectedCount = useMemo(() => {
    if (isAllSelectedAcrossPages) return totalRecords;
    return Object.keys(rowSelection).filter(k => rowSelection[k]).length;
  }, [rowSelection, isAllSelectedAcrossPages, totalRecords]);

  const [isMassUpdateActivePanel, setIsMassUpdateActivePanel] = useState(false);
  const [massSubmitting, setMassSubmitting] = useState(false);
  const [massOperation, setMassOperation] = useState('');
  const [showMassDrawer, setShowMassDrawer] = useState(false);
  const [activeOperationMode, setActiveOperationMode] = useState('followup');
  const [showMassActionsMenu, setShowMassActionsMenu] = useState(false);
  const massMenuAnchorRef = useRef(null);
  const [massOwnerOptions, setMassOwnerOptions] = useState([]);
  const [massCollabOptions, setMassCollabOptions] = useState([]);
  const [massSelectedCollabs, setMassSelectedCollabs] = useState([]);
  const [massCollabSearch, setMassCollabSearch] = useState('');
  const [massCollabDropdownOpen, setMassCollabDropdownOpen] = useState(false);
  const massCollabRef = useRef(null);
  const [showCollabDropdown, setShowCollabDropdown] = useState(false);
  const [collabSearch, setCollabSearch] = useState('');
  const collabRef = useRef(null);
  const [alertConfig, setAlertConfig] = useState({ show: false, message: '', type: 'success' });

  useEffect(() => {
    if (!relatedSearch || relatedSearch.length < 2) {
      setRelatedSuggestions([]);
      setShowRelatedDropdown(false);
      return;
    }
    const timer = setTimeout(async () => {
      try {
        const uid = localStorage.getItem('userId') || '34594';
        const response = await fetch(Related_TO_Suggestion, {
          method: 'POST',
          headers: {
            "Content-Type": "application/json; charset=UTF-8",
            "X-Requested-With": "XMLHttpRequest"
          },
          body: JSON.stringify({
            Token: "-2295521862261168",
            Details: { UserId: parseInt(uid), FilterText: relatedSearch }
          })
        });
        if (response.ok) {
          const result = await response.json();
          let data = result.d || result; // Root fallback
          if (typeof data === 'string') {
            try { data = JSON.parse(data); } catch (e) { }
          }

          let list = [];
          if (data) {
            if (Array.isArray(data)) list = data;
            else if (data.Details && Array.isArray(data.Details)) list = data.Details;
            else if (data.Table && Array.isArray(data.Table)) list = data.Table;
            else if (data.Data && Array.isArray(data.Data)) list = data.Data;
            else if (data.Table1 && Array.isArray(data.Table1)) list = data.Table1;
          }

          setRelatedSuggestions(list);
          setShowRelatedDropdown(list.length > 0);
        }
      } catch (error) {
        console.error("Error fetching related suggestions:", error);
      }
    }, 500);
    return () => clearTimeout(timer);
  }, [relatedSearch]);

  const [showEditTaskModal, setShowEditTaskModal] = useState(false);
  const [editTaskData, setEditTaskData] = useState({
    Id: 0,
    Title: '',
    Description: '',
    TaskType: '',
    DueDate: '',
    DueTime: '',
    Owner: '',
    Collaborators: '',
    SendNotification: true,
    MarkAsCompleted: false
  });
  const [isEditLoading, setIsEditLoading] = useState(false);

  const handleEditTaskClick = async (taskId) => {
    setIsEditLoading(true);
    setShowEditTaskModal(true);
    const userId = localStorage.getItem('userId') || '34594';

    try {
      // 1. Fetch Task Details
      const detailsResp = await axios.post(GET_TASK_DETAILS, {
        Token: "-2295521862261168",
        Details: { Id: parseInt(taskId, 10) }
      });

      if (detailsResp && detailsResp.data && detailsResp.data.Status === 1 && detailsResp.data.Details) {
        const d = detailsResp.data.Details;

        // Parse date and time from d.EndDate or d.date
        const rawDateStr = d.EndDate || d.date || d.startDate || "";
        const parsedDate = parseCustomDate(rawDateStr);

        const taskData = {
          Id: taskId,
          Title: cleanTaskTitle(d.Title || d.taskTitle || ''),
          Description: d.Description || '',
          TaskType: d.TaskType || d.ActivityType || '7',
          DueDate: parsedDate ? parsedDate.toISOString().split('T')[0] : '',
          DueTime: parsedDate ? parsedDate.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false }) : '',
          Owner: d.AssignedTo || d.AssignedToId || d.OwnerId || userId,
          Collaborators: d.CollabratoerUserIds || d.Collaborators || '',
          SendNotification: true,
          MarkAsCompleted: (d.Status || '').toLowerCase() === 'completed' || (d.TaskStatus || '').toLowerCase() === 'completed'
        };
        setEditTaskData(taskData);
        setInitialEditTaskData(taskData);

        // If it's related to a lead, set that too
        if (d.LeadId || d.EnquiryId) {
          setRelatedSelected({
            LeadId: d.LeadId || d.EnquiryId,
            PersonName: d.RelatedTo || d.Name || d.PersonName || 'Related Lead'
          });
        }
      }

      // 2. Fetch necessary dropdowns if not already loaded
      if (taskTypeOptions.length === 0) fetchTaskTypes();
      if (ownerOptions.length === 0) fetchOwners();
      if (collaboratorOptions.length === 0) fetchCollaborators();

    } catch (err) {
      console.error("Error fetching task details for edit:", err);
      Swal.fire('Error', 'Failed to fetch task details', 'error');
      setShowEditTaskModal(false);
    } finally {
      setIsEditLoading(false);
    }
  };

  const handleRowSelectionChange = (newSelection) => {
    const selectedCountOnPage = Object.keys(newSelection).filter(k => newSelection[k]).length;
    const itemsOnPage = filteredTasks.length;

    if (selectedCountOnPage === itemsOnPage && itemsOnPage > 1) {
      if (!isAllSelectedAcrossPages) setIsAllSelectedAcrossPages(true);
    } else {
      if (isAllSelectedAcrossPages) setIsAllSelectedAcrossPages(false);
      if (allIds.length > 0) setAllIds([]);
    }
    setRowSelection(newSelection);
  };

  const fetchAllSelectedIds = async () => {
    try {
      const uid = localStorage.getItem('userId') || '34594';
      const payload = {
        Token: -2295521862261168,
        Details: { UserID: parseInt(uid), Mode: "T", OffsetValue: 0, PagingSize: 5000, FilterText: buildFilterText() }
      };
      const response = await fetch(GETUSERSAPI, {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify(payload)
      });
      const raw = await response.json();
      const d = raw.d ? (typeof raw.d === 'string' ? JSON.parse(raw.d) : raw.d) : (raw.Details || raw);
      const dataArray = d?.Details?.data || d?.data || [];
      return dataArray.map(item => item.id || item.TaskHistoryId || item.Id || item.ID);
    } catch (e) {
      console.error('Error fetching all selected IDs:', e);
      return [];
    }
  };

  const handleMassAction = async (actionId) => {
    if (!actionId) return;

    if (actionId === 'mass_update' && crmOperationPerms && !crmOperationPerms.MassUpdate) {
      Swal.fire('Access Denied', "You don't have permission to perform mass updates.", 'warning');
      return;
    }
    if (actionId === 'delete' && crmOperationPerms && !crmOperationPerms.MassDelete) {
      Swal.fire('Access Denied', "You don't have permission to perform mass deletion.", 'warning');
      return;
    }
    if (actionId === 'mass_sms' && crmOperationPerms && !crmOperationPerms.MassSMS) {
      Swal.fire('Access Denied', "You don't have permission to perform mass SMS.", 'warning');
      return;
    }
    if (actionId === 'mass_email' && crmOperationPerms && !crmOperationPerms.MassEmail) {
      Swal.fire('Access Denied', "You don't have permission to perform mass Email.", 'warning');
      return;
    }
    if (actionId === 'mass_assign' && crmOperationPerms && !crmOperationPerms.MassAssign) {
      Swal.fire('Access Denied', "You don't have permission to perform mass Assignment.", 'warning');
      return;
    }
    if (actionId === 'mass_broadcast' && crmOperationPerms && !crmOperationPerms.MassBroadcast) {
      Swal.fire('Access Denied', "You don't have permission to perform mass Broadcast.", 'warning');
      return;
    }

    if (isAllSelectedAcrossPages && allIds.length === 0) {
      setMassSubmitting(true);
      const ids = await fetchAllSelectedIds();
      setAllIds(ids);
      setMassSubmitting(false);
    }

    if (actionId === 'mass_update') {
      setIsMassUpdateActivePanel(true);
      if (taskTypeOptions.length === 0) fetchTaskTypes();
      if (ownerOptions.length === 0) fetchOwners();
      if (collaboratorOptions.length === 0) fetchCollaborators();
      setMassOwnerOptions(ownerOptions);
      setMassCollabOptions(collaboratorOptions);
    } else {
      setActiveOperationMode(actionId);
      setShowMassDrawer(true);
    }
  };

  const [massUpdateData, setMassUpdateData] = useState({
    Description: '', Remarks: '',
    DueDateTime: new Date().toISOString().slice(0, 16),
    TaskType: '7',
    Owner: '',
    MarkAsCompleted: false
  });

  const [selectedTask, setSelectedTask] = useState(null);
  const [taskDetail, setTaskDetail] = useState(null);
  const [isDetailLoading, setIsDetailLoading] = useState(false);
  const [comments, setComments] = useState([]);
  const [isLoadingComments, setIsLoadingComments] = useState(false);
  const [newComment, setNewComment] = useState("");
  const [newCommentFile, setNewCommentFile] = useState(null);
  const [newCommentFileName, setNewCommentFileName] = useState("");
  const [isSavingInlineComment, setIsSavingInlineComment] = useState(false);

  const fetchComments = async (taskId) => {
    if (!taskId) return;
    setIsLoadingComments(true);
    try {
      const token = localStorage.getItem('token') || '-2295521862261168';
      const payload = {
        Token: token,
        Details: {
          Id: parseInt(taskId, 10),
          Mode: "T"
        }
      };
      const resp = await axios.post(GET_TASK_COMMENTS, payload);
      const rawData = resp?.data?.Details || resp?.data?.d || resp?.data?.data || [];
      try {
        const parsed = typeof rawData === 'string' ? JSON.parse(rawData) : rawData;
        setComments(Array.isArray(parsed) ? parsed : []);
      } catch (e) {
        setComments([]);
      }
    } catch (err) {
      console.error("Error fetching comments:", err);
      setComments([]);
    } finally {
      setIsLoadingComments(false);
    }
  };

  const handleSaveInlineComment = async () => {
    if (!newComment.trim() && !newCommentFile) {
      Swal.fire('Error', 'Please enter a comment or select a file', 'error');
      return;
    }

    if (!selectedTask) return;

    try {
      setIsSavingInlineComment(true);
      const taskIdInt = parseInt(selectedTask.id || selectedTask.TaskHistoryId || '0', 10);
      const userIdInt = parseInt(localStorage.getItem('userId') || '34594', 10);

      const details = {
        Token: API_ENDPOINTS.TOKE.UNIVERSAL_TOKEN.toString(),
        taskAttachment: {
          Remarks: newComment,
          CreatedBy: userIdInt,
          TaskId: taskIdInt,
          ParentId: userIdInt,
          Mode: "C"
        }
      };

      const formData = new FormData();
      formData.append('details', JSON.stringify(details));

      if (newCommentFile) {
        formData.append('file', newCommentFile);
      }

      const resp = await axios.post(Add_Comment, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });

      const status = resp.data?.Status;
      const message = resp.data?.Message;
      const d = resp.data?.d;

      if (status === 1 || message === "Success" || d === "Success" || (typeof resp.data === 'string' && resp.data.includes("Success"))) {
        setNewComment("");
        setNewCommentFile(null);
        setNewCommentFileName("");
        fetchComments(selectedTask.id);
      } else {
        Swal.fire('Error', message || 'Failed to save comment', 'error');
      }
    } catch (err) {
      console.error("Save inline comment error:", err);
      Swal.fire('Error', 'An error occurred while saving the comment', 'error');
    } finally {
      setIsSavingInlineComment(false);
    }
  };

  const buildFilterText = () => {
    const searchParams = new URLSearchParams(location.search);
    const fromDate = searchParams.get('FromDate');
    const toDate = searchParams.get('ToDate');
    const exec = searchParams.get('Executive');
    const isOpen = searchParams.get('Open');
    const isOverdue = searchParams.get('Overdue');
    const filterLabel = location.state?.filterLabel || '';
    
    let baseFilter = "";

    // Check if we came from dashboard metrics
    if (fromDate || toDate || (exec && (isOpen === 'true' || isOverdue === 'true'))) {
        let filterParts = [];
        
        if (isOpen === 'true' || isOverdue === 'true') {
            filterParts.push("(  Status = 'open'  or TaskStatus = 'Over Due'  )");
        }
        
        let isExecutiveClick = false;
        if (fromDate && toDate) {
            filterParts.push(`( ( enddate between convert(date,'${fromDate}') and convert(date,'${toDate}')  ) )`);
        } else {
            filterParts.push(`( ( 1 = 1 ) )`);
            isExecutiveClick = true; // Executive click doesn't pass dates
        }
        
        const uId = localStorage.getItem('userId') || '34594';
        let targetUserId = location.state?.execId || uId;
        if (typeof targetUserId === 'string' && targetUserId.includes(',')) {
            targetUserId = targetUserId.split(',')[1].trim();
        }
        
        if (isExecutiveClick || filterLabel.startsWith('Executive')) {
            filterParts.push(`( AssignedTo in (select User_id from #tbluser where User_ID='${targetUserId}' or ParentID='${targetUserId}') and isnull(outcomesid,0)=0)`);
        } else {
            filterParts.push(`( AssignedTo in (select User_id from #tbluser) and isnull(outcomesid,0)=0)`);
        }
        
        baseFilter = " AND " + filterParts.join(" And ");
    } else {
        if (!taskTabFilter.includes('All')) {
            let statusConditions = [];
            const openPredicate = "((TaskStatus IS NULL OR TaskStatus NOT IN ('completed', 'closed', 'Completed', 'Closed')) AND (EndDate IS NULL OR CAST(EndDate AS DATETIME) >= GETDATE()))";
            const completedPredicate = "(TaskStatus IN ('completed', 'closed', 'Completed', 'Closed'))";
            const overduePredicate = "((TaskStatus IS NULL OR TaskStatus NOT IN ('completed', 'closed', 'Completed', 'Closed')) AND EndDate IS NOT NULL AND CAST(EndDate AS DATETIME) < GETDATE())";

            if (taskTabFilter.includes('Open')) statusConditions.push(openPredicate);
            if (taskTabFilter.includes('Completed')) statusConditions.push(completedPredicate);
            if (taskTabFilter.includes('Overdue')) statusConditions.push(overduePredicate);

            if (statusConditions.length > 0) {
                baseFilter = ` AND (${statusConditions.join(' OR ')})`;
            }
        }
    }

    if (debouncedSearchTerm) {
        const cleanTerm = debouncedSearchTerm.trim().replace(/'/g, "''");
        const searchCondition = `(Title like '%${cleanTerm}%' OR RelatedTo like '%${cleanTerm}%')`;
        if (baseFilter) {
            baseFilter += ` AND ${searchCondition}`;
        } else {
            baseFilter = ` And ${searchCondition}`;
        }
    }

    return baseFilter;
  };

  const handleExportDocuments = async () => {
    try {
      const userId = localStorage.getItem("userId") || "34594";
      const payload = {
        Token: "-2295521862261168",
        Details: {
          UserId: parseInt(userId, 10),
          FilterText: buildFilterText(),
          Mode: "T",
          IsAdmin: false,
          CriteriaName: searchTerm || ""
        }
      };

      Swal.fire({
        title: 'Exporting...',
        text: 'Please wait while we prepare your document',
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        }
      });

      const resp = await axios.post(Export_Doc_URL, payload);

      if (resp.data?.Status === 1 && resp.data?.Details) {
        const fileName = resp.data.Details;

        // ✅ CONFIRMED PATH (via HTTP 200 in probe logs):
        // serviceskit19.azurewebsites.net/SalesTarget/ExportFiles/ returns 200
        // fetch() is blocked by CORS, but window.open() bypasses CORS for navigation
        const downloadUrl = `https://serviceskit19.azurewebsites.net/SalesTarget/ExportFiles/${fileName}`;

        window.open(downloadUrl, '_blank');

        Swal.fire({
          icon: 'success',
          title: 'Export Successful',
          text: 'Your file download has started.',
          timer: 2000,
          showConfirmButton: false
        });
      } else {
        Swal.fire('Error', resp.data?.Message || 'Failed to export documents', 'error');
      }
    } catch (err) {
      console.error("Export error:", err);
      Swal.fire('Error', 'An error occurred during export', 'error');
    }
  };

  const fetchTaskDetails = async (taskId) => {
    if (!taskId) return;
    setIsDetailLoading(true);
    const userId = localStorage.getItem("userId") || "34594";
    try {
      const resp = await axios.post(GET_TASK_DETAILS, { Token: "-2295521862261168", Details: { Id: parseInt(taskId, 10) } });
      if (resp && resp.data && resp.data.Status === 1 && resp.data.Details) {
        setTaskDetail(resp.data.Details);
      } else {
        setTaskDetail(null);
      }
    } catch (err) {
      console.error("Error fetching task details:", err);
      setTaskDetail(null);
    } finally {
      setIsDetailLoading(false);
    }
  };

  useEffect(() => {
    if (selectedTask) {
      fetchComments(selectedTask.id);
      fetchTaskDetails(selectedTask.id);
    } else {
      setComments([]);
      setTaskDetail(null);
    }
  }, [selectedTask]);

  const [taskTabFilter, setTaskTabFilter] = useState(() => {
    const dFilter = location.state?.dashboardFilter;
    if (dFilter && typeof dFilter === 'object') {
      let newFilters = [];
      if (dFilter.Overdue) newFilters.push('Overdue');
      if (dFilter.Open) newFilters.push('Open');
      if (dFilter.Completed) newFilters.push('Completed');
      if (newFilters.length > 0) return newFilters;
    }
    return ['All'];
  });
  const [viewMode, setViewMode] = useState('table');
  const [calendarView, setCalendarView] = useState('month');
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 25;
  const currentChunk = Math.floor((currentPage - 1) * itemsPerPage / 200);
  const [advancedFilters, setAdvancedFilters] = useState(null);

  const taskFields = [
    { label: 'Task Title', value: 'taskTitle' },
    { label: 'Lead Name', value: 'name' },
    { label: 'Enquiry ID', value: 'enquiryId' },
    { label: 'Description', value: 'description' },
    { label: 'DueDate', value: 'endDate', type: 'date' },
    { label: 'Status', value: 'statusLabel' },
    { label: 'Outcome', value: 'outcomeName' },
    { label: 'Owner', value: 'ownerName' }
  ];

  const handleAdvancedFilterSubmit = (newFilters) => {
    setAdvancedFilters(prev => ({ ...newFilters, sortBy: prev?.sortBy || 'created_desc' }));
  };

  const handleSortChange = (newSort) => {
    setAdvancedFilters(prev => ({ ...(prev || {}), sortBy: newSort }));
  };

  const [globalStats, setGlobalStats] = useState({
    total: 0,
    completed: 0,
    overdue: 0,
    open: 0,
    absoluteTotal: 0 // Track the global total separately
  });

  const clearDashboardFilter = () => {
    if (location.search) {
      navigate('/tasks', { replace: true, state: {} });
    }
  };

  const handleStatusFilterClick = (status) => {
    if (status === 'ResetAll') {
      setTaskTabFilter(['All']);
      setSearchTerm('');
      setAdvancedFilters(null);
      setCustomSearchId(0);
      setCurrentPage(1);
      return;
    }

    if (status === 'All') {
      setTaskTabFilter(['All']);
    } else {
      setTaskTabFilter(prev => {
        if (prev.includes(status)) {
          const filtered = prev.filter(s => s !== status);
          return filtered.length === 0 ? ['All'] : filtered;
        } else {
          const next = prev.filter(s => s !== 'All');
          return [...next, status];
        }
      });
    }
    setCurrentPage(1);
  };

  const handleViewLead = (id) => {
    setViewingLeadId(id);
    setViewingDetailTask(null);
  };

  const handleMarkAsCompleted = (task) => {
    setTaskForOutcome(task);
    setOutcomeData({ outcomeId: '', remarks: '' });
    setShowOutcomeModal(true);
  };

  const handleSaveOutcome = async () => {
    if (!outcomeData.outcomeId) {
      setAlertConfig({
        show: true,
        type: 'error',
        title: 'Error',
        message: 'Please select an outcome',
        onConfirm: () => setAlertConfig(prev => ({ ...prev, show: false }))
      });
      return;
    }

    const taskId = taskForOutcome.id || taskForOutcome.TaskHistoryId;

    const payload = {
      Token: API_ENDPOINTS.TOKE.UNIVERSAL_TOKEN,
      Details: {
        Id: taskId,
        OutcomeId: parseInt(outcomeData.outcomeId, 10),
        Remarks: outcomeData.remarks || "Task completed successfully"
      }
    };

    try {
      setIsSubmittingTask(true);
      const response = await axios.post(Save_Mark_As_Complete, payload);
      if (response && response.data && (response.data.Status === 1 || response.data.d === "Success")) {
        setShowOutcomeModal(false);
        setAlertConfig({
          show: true,
          type: 'success',
          title: 'Success',
          message: 'Task marked as completed!',
          onConfirm: () => {
            setAlertConfig(prev => ({ ...prev, show: false }));
            fetchTasks();
          }
        });
      } else {
        setAlertConfig({
          show: true,
          type: 'error',
          title: 'Error',
          message: response.data?.Message || 'Failed to update task.',
          onConfirm: () => setAlertConfig(prev => ({ ...prev, show: false }))
        });
      }
    } catch (error) {
      console.error("Save outcome error:", error);
      setAlertConfig({
        show: true,
        type: 'error',
        title: 'Error',
        message: 'An error occurred.',
        onConfirm: () => setAlertConfig(prev => ({ ...prev, show: false }))
      });
    } finally {
      setIsSubmittingTask(false);

    }
  };





  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearchTerm(searchTerm);
      // Removed redundant fetchGlobalStats call that was overwriting list data
    }, 500);
    return () => clearTimeout(handler);
  }, [searchTerm]);

  // Redundant: taskTabFilter is already set in the initial state from location.state

  // Global click and scroll listener to close dropdowns
  useEffect(() => {
    const handleEvents = (e) => {
      if (e.type === 'scroll') {
        if (e.target.closest && (e.target.closest('.collab-dropdown-menu') || e.target.closest('.related-suggestions-list'))) {
          return;
        }
        window.dispatchEvent(new CustomEvent('close-all-option-menus'));
        setActiveMeatball(null);
        setActiveSettingsMenu(null);
        setShowRelatedDropdown(false);
        setShowCollabDropdown(false);
        setMassCollabDropdownOpen(false);
        return;
      }

      // Handle Click Outside
      setActiveMeatball(null);
      setActiveSettingsMenu(null);
      if (relatedRef.current && !relatedRef.current.contains(e.target)) {
        setShowRelatedDropdown(false);
      }
      if (collabRef.current && !collabRef.current.contains(e.target)) {
        setShowCollabDropdown(false);
      }
      if (massCollabRef.current && !massCollabRef.current.contains(e.target)) {
        setMassCollabDropdownOpen(false);
      }
    };

    document.addEventListener('click', handleEvents);
    window.addEventListener('scroll', handleEvents, true); // capture: true to catch scrolls in any sub-container
    fetchGlobalStats(); // Initial fetch for global stats
    return () => {
      document.removeEventListener('click', handleEvents);
      window.removeEventListener('scroll', handleEvents, true);
    };
  }, []);

  useEffect(() => {
    if (showAddTaskModal) {
      fetchTaskTypes();
      fetchOwners();
      fetchCollaborators();
    }
  }, [showAddTaskModal]);

  useEffect(() => {
    if (isMassUpdateActivePanel) {
      const fetchMassOptions = async () => {
        const uid = localStorage.getItem('userId') || '34594';
        try {
          const res = await fetch(FOR_OWNER, {
            method: 'POST', headers: { "Content-Type": "application/json; charset=UTF-8" },
            body: JSON.stringify({ Token: "-2295521862261168", Details: { UserId: parseInt(uid, 10) } })
          });
          if (res.ok) {
            const data = await res.json();
            const rawData = data?.Details?.data || data?.Details || data?.d || [];
            let parsed = Array.isArray(rawData) ? rawData : [];
            if (typeof rawData === 'string') { try { parsed = JSON.parse(rawData); } catch(e){} }
            setMassOwnerOptions(Array.isArray(parsed) ? parsed : []);
          }
        } catch (e) { console.error("Mass owners fetch failed", e); }

        try {
          const res = await fetch(Collabrator_API, {
            method: 'POST', headers: { "Content-Type": "application/json; charset=UTF-8" },
            body: JSON.stringify({ Token: "-2295521862261168", Details: { UserId: parseInt(uid, 10) } })
          });
          if (res.ok) {
            const data = await res.json();
            const rawData = data?.Details?.data || data?.Details || data?.d || [];
            let parsed = Array.isArray(rawData) ? rawData : [];
            if (typeof rawData === 'string') { try { parsed = JSON.parse(rawData); } catch(e){} }
            setMassCollabOptions(Array.isArray(parsed) ? parsed : []);
          }
        } catch (e) { console.error("Mass collabs fetch failed", e); }
      };
      fetchMassOptions();
    }
  }, [isMassUpdateActivePanel]);

  const fetchGlobalStats = async (filters = {}) => {
    try {
      const ustrUserId = localStorage.getItem('userId') || '34594';

      const payload = {
          Token: "-2295521862261168",
          Details: {
              Mode: "GetCounterForPages",
              Details: {
                  PageName: "Task",
                  UserId: parseInt(ustrUserId),
                  Mode: "T",
                  FilterText: "",
                  CriteriaName: ""
              }
          }
      };

      const reqOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify(payload)
      };

      const STATS_API_URL = `${NEWV3_BASE_URL}${API_ENDPOINTS.COMMON.HELP_DATA_BIND}`;
      const res = await fetch(STATS_API_URL, reqOptions);
      const data = await (res.ok ? res.json() : {});
      
      if (data && data.Details && data.Details.length > 0) {
        const stats = data.Details[0];
        setGlobalStats(prev => ({
          ...prev,
          total: stats.TotalCount || 0,
          absoluteTotal: stats.TotalCount || 0,
          completed: stats.CompletedCount || 0,
          overdue: stats.OverdueCount || 0,
          open: stats.OpenCount || 0
        }));
      }
    } catch (error) {
      console.error("Error fetching global stats:", error);
    }
  };



  const fetchTaskTypes = async () => {
    try {
      const uid = localStorage.getItem('userId') || '34594';
      const response = await fetch(Task_type, {
        method: 'POST',
        headers: { "Content-Type": "application/json; charset=UTF-8" },
        body: JSON.stringify({ Token: "-2295521862261168", Details: { UserId: parseInt(uid, 10) } })
      });
      if (response.ok) {
        const result = await response.json();
        setTaskTypeOptions(result.Details || result.d || []);
      }
    } catch (error) { console.error("Error fetching task types:", error); }
  };

  const fetchOwners = async () => {
    try {
      const uid = localStorage.getItem('userId') || '34594';
      const response = await fetch(Collabrator, {
        method: 'POST',
        headers: { "Content-Type": "application/json; charset=UTF-8" },
        body: JSON.stringify({ Token: "-2295521862261168", Details: { UserId: parseInt(uid, 10) } })
      });
      if (response.ok) {
        const result = await response.json();
        const rawData = result?.Status === 1 && result?.Details ? result.Details : (result?.d || result?.Data || result?.data || result || []);
        let parsed = Array.isArray(rawData) ? rawData : [];
        if (typeof rawData === 'string') { try { parsed = JSON.parse(rawData); } catch(e){} }
        setOwnerOptions(Array.isArray(parsed) ? parsed : []);
      }
    } catch (error) { console.error("Error fetching owners:", error); }
  };

  const fetchCollaborators = async () => {
    try {
      const uid = localStorage.getItem('userId') || '34594';
      const response = await fetch(Collabrator, {
        method: 'POST',
        headers: { "Content-Type": "application/json; charset=UTF-8" },
        body: JSON.stringify({ Token: "-2295521862261168", Details: { UserId: parseInt(uid, 10) } }),
      });
      if (response.ok) {
        const result = await response.json();
        const rawData = result?.Status === 1 && result?.Details ? result.Details : (result?.d || result?.Data || result?.data || result || []);
        let parsed = Array.isArray(rawData) ? rawData : [];
        if (typeof rawData === 'string') { try { parsed = JSON.parse(rawData); } catch(e){} }
        setCollaboratorOptions(Array.isArray(parsed) ? parsed : []);
      }
    } catch (error) { console.error("Error fetching collaborators:", error); }
  };

  const handleEditTaskSubmit = async () => {
    if (editTaskData.SendNotification) {
      setAlertConfig({
        show: true,
        type: 'info',
        title: 'Alert',
        message: 'SMS SenderId not configured',
        onConfirm: () => setAlertConfig(prev => ({ ...prev, show: false }))
      });
      return;
    }

    if (!editTaskData.Title.trim()) { alert("Please enter a title"); return; }
    setIsSubmittingTask(true);
    try {
      if (!editTaskData.DueDate || !editTaskData.DueTime) {
        alert("Please select both due date and time");
        setIsSubmittingTask(false);
        return;
      }
      const d = new Date(`${editTaskData.DueDate}T${editTaskData.DueTime}`);
      if (isNaN(d.getTime())) {
        alert("Invalid Date or Time selection. Please check the date and time format.");
        setIsSubmittingTask(false);
        return;
      }
      // Check for extreme years (e.g., < 1900 or > 2100) to prevent API errors
      if (d.getFullYear() < 1900 || d.getFullYear() > 2100) {
        alert("Please enter a valid date between 1900 and 2100");
        setIsSubmittingTask(false);
        return;
      }

      const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
      const formattedEndDate = `${d.getDate().toString().padStart(2, '0')} ${months[d.getMonth()]} ${d.getFullYear()} ${d.getHours().toString().padStart(2, '0')}:${d.getMinutes().toString().padStart(2, '0')}`;
      const uid = localStorage.getItem('userId') || '34594';

      const payload = {
        Token: "-2295521862261168",
        Details: {
          TimeZone: "India Standard Time",
          insertUpdateTask: {
            Id: parseInt(editTaskData.Id, 10),
            Title: editTaskData.Title,
            Description: editTaskData.Description,
            Remarks: "",
            Address: "",
            StartDate: "",
            AssignedTo: parseInt(editTaskData.Owner),
            BySMS: false,
            CollabratoerUserIds: Array.isArray(editTaskData.Collaborators) ? editTaskData.Collaborators.join('#') : (typeof editTaskData.Collaborators === 'string' ? editTaskData.Collaborators.split(',').join('#') : editTaskData.Collaborators),
            CompleteAddress: "",
            CreatedBy: 0,
            DLTTemplateIDForNotify: "",
            DLTTemplateIDForSMSReminder: "",
            EndDate: formattedEndDate,
            IsActive: true,
            IsAppointment: false,
            IsEmail: false,
            IsSMS: false,
            IsTask: true,
            Latitude: "",
            LeadId: relatedSelected ? (relatedSelected.LeadId || relatedSelected.Id || 0) : 0,
            Longitude: "",
            NotifyMe: editTaskData.SendNotification,
            OutcomesId: 0,
            SmsSchedule: "",
            Status: editTaskData.MarkAsCompleted ? "completed" : "open",
            TaskId: parseInt(editTaskData.TaskId, 10) || 0,
            TaskType: ""
          }
        }
      };

      const response = await fetch(ADD_TASK_URL, {
        method: 'POST',
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
          "X-Requested-With": "XMLHttpRequest"
        },
        body: JSON.stringify(payload)
      });

      const text = await response.text();
      let data;
      try { data = JSON.parse(text); if (data.d && typeof data.d === 'string') data = JSON.parse(data.d); else if (data.d) data = data.d; } catch (e) { data = text; }

      const isSuccess = response.ok && (data?.IsInserted || data?.IsUpdated || (typeof text === 'string' && (text.includes('"IsInserted":true') || text.includes('"IsUpdated":true'))));

      if (isSuccess || data?.Message === "Success") {
        Swal.fire({ icon: 'success', title: 'Success', text: 'Task updated successfully.', confirmButtonColor: '#28a745' });
        setShowEditTaskModal(false);
        fetchTasks(); // Refresh list
      } else {
        Swal.fire({ icon: 'error', title: 'Error', text: data?.Message || "Failed to update task" });
      }
    } catch (error) {
      console.error("Error updated task:", error);
      Swal.fire({ icon: 'error', title: 'Error', text: "An error occurred. Please try again." });
    }
    finally { setIsSubmittingTask(false); }
  };

  const handleAddTaskSubmit = async () => {
    if (addTaskData.SendNotification) {
      setAlertConfig({
        show: true,
        type: 'info',
        title: 'Alert',
        message: 'SMS SenderId not configured',
        onConfirm: () => setAlertConfig(prev => ({ ...prev, show: false }))
      });
      return;
    }

    if (!addTaskData.Title.trim()) { alert("Please enter a title"); return; }
    setIsSubmittingTask(true);
    try {
      if (!addTaskData.DueDate || !addTaskData.DueTime) {
        alert("Please select both due date and time");
        setIsSubmittingTask(false);
        return;
      }
      const d = new Date(`${addTaskData.DueDate}T${addTaskData.DueTime}`);
      if (isNaN(d.getTime())) {
        alert("Invalid Date or Time selection. Please check the date and time format.");
        setIsSubmittingTask(false);
        return;
      }
      // Check for extreme years
      if (d.getFullYear() < 1900 || d.getFullYear() > 2100) {
        alert("Please enter a valid date between 1900 and 2100");
        setIsSubmittingTask(false);
        return;
      }

      const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
      const formattedEndDate = `${d.getDate().toString().padStart(2, '0')} ${months[d.getMonth()]} ${d.getFullYear()} ${d.getHours().toString().padStart(2, '0')}:${d.getMinutes().toString().padStart(2, '0')}`;
      const uid = localStorage.getItem('userId') || '34594';

      const payload = {
        Token: "-2295521862261168",
        Details: {
          TimeZone: "India Standard Time",
          insertUpdateTask: {
            Id: 0,
            Title: addTaskData.Title,
            Description: addTaskData.Description,
            Remarks: "",
            Address: "",
            StartDate: "",
            AssignedTo: parseInt(addTaskData.Owner),
            BySMS: false,
            CollabratoerUserIds: Array.isArray(addTaskData.Collaborators) ? addTaskData.Collaborators.join('#') : (typeof addTaskData.Collaborators === 'string' ? addTaskData.Collaborators.split(',').join('#') : addTaskData.Collaborators),
            CompleteAddress: "",
            CreatedBy: 0,
            DLTTemplateIDForNotify: "",
            DLTTemplateIDForSMSReminder: "",
            EndDate: formattedEndDate,
            IsActive: true,
            IsAppointment: false,
            IsEmail: false,
            IsSMS: false,
            IsTask: true,
            Latitude: "",
            LeadId: relatedSelected ? (relatedSelected.LeadId || relatedSelected.Id || 0) : 0,
            Longitude: "",
            NotifyMe: addTaskData.SendNotification,
            OutcomesId: 0,
            SmsSchedule: "",
            Status: "open",
            TaskId: parseInt(addTaskData.TaskType, 10) || 0,
            TaskType: ""
          }
        }
      };

      const response = await fetch(ADD_TASK_URL, {
        method: 'POST',
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
          "X-Requested-With": "XMLHttpRequest"
        },
        body: JSON.stringify(payload)
      });

      const text = await response.text();
      let data;
      try { data = JSON.parse(text); if (data.d && typeof data.d === 'string') data = JSON.parse(data.d); else if (data.d) data = data.d; } catch (e) { data = text; }

      const isSuccess = response.ok && (data?.IsInserted || data?.IsUpdated || (typeof text === 'string' && (text.includes('"IsInserted":true') || text.includes('"IsUpdated":true'))));

      if (isSuccess || data?.Message === "Success") {
        Swal.fire({ icon: 'success', title: 'Success', text: 'Task saved successfully.', confirmButtonColor: '#28a745' });
        // Reset form to fresh defaults
        setAddTaskData({
          Title: `NewTask_${new Date().toISOString().replace(/[-:T.Z]/g, '').slice(0, 14)}`,
          Description: '',
          TaskType: '7',
          DueDate: new Date().toISOString().split('T')[0],
          DueTime: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false }),
          Owner: localStorage.getItem('userId') || '34594',
          Collaborators: '',
          SendNotification: false
        });
        setRelatedSelected(null);
        setRelatedSearch('');
        setShowAddTaskModal(false);
        fetchTasks(); // Refresh list
      } else {
        Swal.fire({ icon: 'error', title: 'Error', text: data?.Message || "Failed to create task" });
      }
    } catch (error) {
      console.error("Error creating task:", error);
      Swal.fire({ icon: 'error', title: 'Error', text: "An error occurred. Please try again." });
    }
    finally { setIsSubmittingTask(false); }
  };

  // parseResponse returns the parsed JSON if possible, otherwise raw text.
  const parseResponse = async (resp) => {
    const text = await resp.text();
    if (!text) return null;
    try {
      return JSON.parse(text);
    } catch (e) {
      return text;
    }
  };

  // Extract usable payload from possible wrappers:
  // - top-level object with .data
  // - object with .d (asmx style)
  // - direct object/array
  const extractPayload = (res) => {
    if (!res) return res;
    if (res.data !== undefined) return res; // has data property as before
    if (res.Details !== undefined) return res; // some endpoints return Details
    if (res.d !== undefined) {
      // .d may itself be a stringified JSON or an object
      if (typeof res.d === 'string') {
        try {
          return JSON.parse(res.d);
        } catch {
          return res.d;
        }
      }
      return res.d;
    }
    return res;
  };


  // Fetch Custom Export data when modal opens

  useEffect(() => {
    if (isCustomDownloadOpen) {
      const fetchCustomExportData = async () => {
        const uid = localStorage.getItem('userId') || '34594';
        const token = API_ENDPOINTS.TOKE.UNIVERSAL_TOKEN.toString();

        // 1. Fetch Placeholders
        try {
          const NEWV3_BASE_URL = (process.env.REACT_APP_SERVICES_API_BASE_URL || '').replace(/\/$/, '');
          const phUrl = `${NEWV3_BASE_URL}/UserCRM/FuncToGetEntityPlaceHolder`;
          const res = await fetch(phUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ Token: token, Details: { strEntityName: "Lead", strParentID: uid } })
          });
          const result = await res.json();
          if (result && result.Status === 1 && result.Details) {
            setCustomExportFields(result.Details);
          } else if (result && result.d) {
            setCustomExportFields(result.d);
          }
        } catch (e) {
          console.error('Error fetching placeholders:', e);
        }

        // 2. Fetch Settings
        try {
          const settingsUrl = `${API_BASE_SERVICES}${API_ENDPOINTS.COMMON.EXPORT_DATA_SETTING}`;
          const payload = {
            Details: {
              Id: 0,
              SettingName: "",
              PageUrl: "/UserCRMCampaign/ToDo/Task.aspx",
              CsvColumns: "",
              Section: "Task",
              EntityName: "Entity",
              UserId: uid,
              Mode: "get"
            },
            Token: token
          };
          const res = await fetch(settingsUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload)
          });
          const result = await res.json();
          if (result && result.Details && result.Details.data) {
            setCustomSettings(result.Details.data);
          } else if (result && result.data) {
            setCustomSettings(result.data);
          }
        } catch (e) {
          console.error('Error fetching settings:', e);
        }
      };
      fetchCustomExportData();
    }
  }, [isCustomDownloadOpen]);


  // Save export setting

  const handleSaveExportSetting = async () => {
    let nameToSave = exportSettingName;
    let existingId = 0;

    if (!nameToSave && selectedCustomSetting) {
      const currentSetting = customSettings.find(s => s.Id.toString() === selectedCustomSetting);
      if (currentSetting) {
        nameToSave = currentSetting.SettingName;
        existingId = currentSetting.Id;
      }
    }

    if (!nameToSave || selectedExportFields.length === 0) {
      alert("Please enter a name for the setting and select at least one field.");
      return;
    }

    const uid = localStorage.getItem('userId') || '34594';
    try {
      const token = API_ENDPOINTS.TOKE.UNIVERSAL_TOKEN.toString();
      const payload = {
        Details: {
          Id: existingId,
          SettingName: nameToSave,
          PageUrl: "/UserCRMCampaign/ToDo/Task.aspx",
          CsvColumns: selectedExportFields.join(','),
          Section: "Task",
          EntityName: "Lead",
          UserId: uid,
          Mode: "set"
        },
        Token: token
      };

      const settingsUrl = `${API_BASE_SERVICES}${API_ENDPOINTS.COMMON.EXPORT_DATA_SETTING}`;
      const res = await fetch(settingsUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });
      const result = await res.json();

      if (result && (result.Status === 1 || (result.Details && result.Details.Status === 1))) {
        alert("Setting saved successfully!");
        setExportSettingName('');
        // Re-fetch settings
        const fetchSettingsAfterSave = async () => {
          const sPayload = {
            Details: {
              Id: 0,
              SettingName: "",
              PageUrl: "/UserCRMCampaign/ToDo/Task.aspx",
              CsvColumns: "",
              Section: "Task",
              EntityName: "Entity",
              UserId: uid,
              Mode: "get"
            },
            Token: token
          };
          try {
            const sRes = await fetch(settingsUrl, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify(sPayload)
            });
            const sResult = await sRes.json();
            if (sResult && sResult.Details && sResult.Details.data) {
              setCustomSettings(sResult.Details.data);
            } else if (sResult && sResult.data) {
              setCustomSettings(sResult.data);
            }
          } catch (e) {
            console.error('Error re-fetching settings after save:', e);
          }
        };
        fetchSettingsAfterSave();
      } else {
        const msg = (result && (result.Message || result.MessageText)) || 'Failed to save';
        alert("Failed to save: " + msg);
      }
    } catch (e) {
      console.error('Error saving setting:', e);
      alert("Error saving setting. Check console.");
    }
  };



  // Handle custom download submit (ExportWidgetDownload)
  const handleCustomDownloadSubmit = async () => {
    if (selectedExportFields.length === 0) {
      alert("Select fields first.");
      return;
    }
    setIsDownloading(true);
    const uid = localStorage.getItem('userId') || '34594';
    try {
      const payload = {
        UserId: uid,
        EntityName: "Lead",
        PageMode: "Task",
        Mode: "T",
        CriteriaName: searchTerm || "",
        FilterText: buildFilterText(),
        csvColumnList: selectedExportFields.join(','),
        PageSection: "Task",
        FollowUpType: "AssignedTo",
        AssignedTo: "0",
        CreatedBy: "",
        NextStatusFromDate: "",
        NextStatusToDate: "",
        CreatedFromDate: "",
        CreatedToDate: "",
        LeadId: "0",
        Remarks: "",
        Overdue: "false",
        DueToday: "false",
        Scheduled: "false",
        NoFollowUp: "false",
        IsReAssign: "false"
      };

      const form = document.createElement('form');
      form.method = 'POST';
      form.action = 'https://wcfkit19.azurewebsites.net/UserCRMCampaign/Service/CallReportService.asmx/ExportWidgetDownload';
      form.target = '_blank';

      Object.keys(payload).forEach(key => {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = key;
        input.value = payload[key];
        form.appendChild(input);
      });

      document.body.appendChild(form);
      form.submit();
      document.body.removeChild(form);

    } catch (e) {
      console.error('Download error:', e);
      alert("An error occurred during download.");
    } finally {
      setIsDownloading(false);
    }
  };


  // CSV Export (client-side) - unchanged

  const handleExportTasks = () => {
    // Client-side CSV Export
    if (!filteredTasks || filteredTasks.length === 0) {
      alert("No tasks to export.");
      return;
    }

    const headers = [
      "LeadNo",
      "Title",
      "Description",
      "Address",
      "StartDate",
      "EndDate",
      "STATUS",
      "RelatedTo",
      "AssignedTo",
      "CreatorName",
      "Completed",
      "Remarks",
      "Collaboraters",
      "OwnerName",
      "OutcomeName",
      "TaskStatus",
      "Threshold"
    ];

    // Helper to format date for CSV (dd-MMM-yyyy) to avoid ##### in Excel
    const formatExcelDate = (dateString) => {
      if (!dateString || dateString === '0' || dateString === 'null') return '';
      const s = String(dateString).trim();
      // Return 1900-era placeholder strings directly if the API provides them
      if (s.startsWith('1900') || s.startsWith('01 Jan 1900') || s.startsWith('01-Jan-1900')) return '01-Jan-1900';

      // Handle Microsoft /Date(timestamp)/ format
      const msMatch = s.match(/\/Date\((-?\d+)\)\//);
      if (msMatch) {
        const d = new Date(parseInt(msMatch[1], 10));
        if (!isNaN(d.getTime()) && d.getFullYear() > 1900) {
          return d.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' }).replace(/ /g, '-');
        }
        return '';
      }

      // Normalise "DD MMM YYYY HH:mm" or "DD-MMM-YYYY HH:mm" → ISO-like for native parsing
      const months = { jan:0, feb:1, mar:2, apr:3, may:4, jun:5, jul:6, aug:7, sep:8, oct:9, nov:10, dec:11 };
      const parts = s.split(/[\sT,]+/);
      const datePart = parts[0];
      const dateSplit = datePart.split(/[-/.]/);

      let year, month, day;
      if (dateSplit.length >= 3) {
        if (dateSplit[0].length === 4) {
          // YYYY-MM-DD
          year = parseInt(dateSplit[0], 10);
          month = parseInt(dateSplit[1], 10) - 1;
          day = parseInt(dateSplit[2], 10);
        } else {
          // DD-MMM-YYYY or DD-MM-YYYY
          day = parseInt(dateSplit[0], 10);
          month = isNaN(dateSplit[1]) ? (months[dateSplit[1].toLowerCase().slice(0, 3)] ?? 0) : parseInt(dateSplit[1], 10) - 1;
          year = dateSplit[2].length === 2 ? 2000 + parseInt(dateSplit[2], 10) : parseInt(dateSplit[2], 10);
        }
      } else if (parts.length >= 3 && isNaN(parts[1])) {
        // DD MMM YYYY
        day = parseInt(parts[0], 10);
        month = months[parts[1].toLowerCase().slice(0, 3)] ?? 0;
        year = parseInt(parts[2], 10);
      } else {
        // Fallback: try native Date directly
        const d = new Date(s);
        if (!isNaN(d.getTime()) && d.getFullYear() > 1900) {
          return d.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' }).replace(/ /g, '-');
        }
        return '';
      }

      if (!year || isNaN(year) || year <= 1900) return '';
      const d = new Date(year, month, day);
      if (isNaN(d.getTime())) return '';
      return d.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' }).replace(/ /g, '-');
    };

    // Helper to escape CSV values and add spacing for Excel
    const escapeCSV = (val) => {
      if (val === null || val === undefined) return '""';
      let str = String(val).replace(/"/g, '""');
      // Adding a leading space (" " + str) provides visual spacing in Excel 
      // and prevents auto-formatting of large numbers/dates
      return `" ${str}"`;
    };

    // Map data to rows
    const rows = filteredTasks.map(t => {
      const maskedT = maskObject({ ...t });
      // Determine actual task status for conditional date display
      const taskStatusLower = (maskedT.status || maskedT.taskStatus || maskedT.statusLabel || '').toLowerCase().trim();
      const isActuallyCompleted = taskStatusLower === 'completed' || taskStatusLower === 'closed';

      // Pass rawStart directly to formatExcelDate so 1900 dates can be formatted as 01-Jan-1900 per user request
      const rawStart = maskedT.startDate || maskedT.StartDate || '';

      return [
        maskedT.enquiryId || maskedT.LeadId || maskedT.PID || '',
        maskedT.taskTitle || maskedT.Title || '',
        maskedT.description || maskedT.Description || '',
        maskedT.Address || maskedT.address || maskedT.FullAddress || '',
        formatExcelDate(rawStart),           // StartDate — real start / created / due date
        formatExcelDate(maskedT.endDate || maskedT.EndDate),               // EndDate (Due Date)
        maskedT.status || maskedT.statusLabel || maskedT.Status || '',          // STATUS
        maskedT.name || maskedT.RelatedTo || maskedT.PersonName || '',
        maskedT.assignedTo || maskedT.AssignedTo || maskedT.AssignedToName || '',
        maskedT.creatorName || maskedT.CreatedByName || maskedT.FName || '',
        isActuallyCompleted ? formatExcelDate(maskedT.modifiedDate || maskedT.ModifiedDate || maskedT.modifiedOn || maskedT.ModifiedOn || maskedT.completedDate || maskedT.CompletedDate || '') : '',  // Completed — only for completed tasks
        maskedT.remarks || maskedT.Remarks || '',
        maskedT.Collaborators || maskedT.collaboratorList || '',
        maskedT.ownerName || maskedT.OwnerName || maskedT.DealOwnerName || '',
        maskedT.outcomeName || maskedT.OutcomeName || '',
        maskedT.taskStatus || maskedT.TaskStatus || '',
        maskedT.Threshold || maskedT.threshold || '0'
      ];
    });

    let csvContent = headers.map(h => `"${h}"`).join(",") + "\n";
    rows.forEach(row => {
      csvContent += row.map(escapeCSV).join(",") + "\n";
    });

    // Create Download Link
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement("a");
    if (link.download !== undefined) {
      const url = URL.createObjectURL(blob);
      link.setAttribute("href", url);
      link.setAttribute("download", `Tasks_Export_${new Date().toISOString().slice(0, 10)}.csv`);
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      alert("Export Downloaded Successfully! Please check your file.");
    }
  };




  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setCommentFile(file);
      setCommentFileName(file.name);
    }
  };

  const handleSaveComment = async () => {
    if (!commentText.trim()) {
      Swal.fire('Error', 'Please enter a comment', 'error');
      return;
    }

    const taskIdInt = parseInt(taskForComment?.TaskHistoryId || taskForComment?.id || taskForComment?.Id || '0', 10);
    const userIdInt = parseInt(localStorage.getItem('userId') || '34594', 10);

    const details = {
      Token: API_ENDPOINTS.TOKE.UNIVERSAL_TOKEN.toString(),
      taskAttachment: {
        Remarks: commentText,
        CreatedBy: userIdInt,
        TaskId: taskIdInt,
        ParentId: userIdInt,
        Mode: "C"
      }
    };

    const formData = new FormData();
    formData.append('details', JSON.stringify(details));

    if (commentFile) {
      formData.append('file', commentFile);
    }

    try {
      setIsSavingComment(true);
      const resp = await axios.post(Add_Comment, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });

      // The API return format can vary, checking multiple possible success indicators
      const status = resp.data?.Status;
      const message = resp.data?.Message;
      const d = resp.data?.d;

      if (status === 1 || message === "Success" || d === "Success" || (typeof resp.data === 'string' && resp.data.includes("Success"))) {
        Swal.fire({
          icon: 'success',
          title: 'Saved',
          text: 'Comment added successfully',
          timer: 2000,
          showConfirmButton: false
        });
        setShowCommentModal(false);
        // Refresh list if necessary, or just rely on state
      } else {
        Swal.fire('Error', message || 'Failed to save comment', 'error');
      }
    } catch (err) {
      console.error("Save comment error:", err);
      Swal.fire('Error', 'An error occurred while saving the comment', 'error');
    } finally {
      setIsSavingComment(false);
    }
  };


  // Delete Task (Common/CommonActionModebased)

  const handleDeleteTask = async (taskId) => {
    const result = await Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!'
    });

    if (result.isConfirmed) {
      try {
        const userId = parseInt(localStorage.getItem('userId') || '34594', 10);
        const payload = {
          Token: "-2295521862261168",
          Details: {
            Id: parseInt(taskId, 10),
            UserId: userId
          }
        };

        const response = await axios.post(Delete_Task, payload);

        if (response && response.data && (response.data.Status === 1 || response.data.d === "Success" || response.data.Message === "Success" || (typeof response.data === 'string' && response.data.includes("Success")))) {
          Swal.fire(
            'Removed!',
            'Your task has been deleted.',
            'success'
          );
          fetchTasks(); // Refresh the list
        } else {
          Swal.fire(
            'Error!',
            response.data?.Message || 'Failed to delete task.',
            'error'
          );
        }
      } catch (error) {
        console.error("Delete task error:", error);
        Swal.fire(
          'Error!',
          'An error occurred while deleting the task.',
          'error'
        );
      }
    }
  };



  // Fetch tasks logic
  const fetchTasks = async () => {
    setLoading(true);

    try {
      setLoading(true);
      const userId = localStorage.getItem('userId') || '34594';
      
      const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({
          Token: "-2295521862261168",
          Details: {
            FilterText: buildFilterText() || "",
            UserId: parseInt(userId),
            Mode: "T",
            OffsetValue: parseInt((currentPage - 1) * itemsPerPage),
            PagingSize: itemsPerPage,
            CriteriaName: ""
          }
        })
      };

      const response = await fetch(GETUSERSAPI, requestOptions);
      if (!response.ok) {
        throw new Error(`Server responded with ${response.status}`);
      }

      const parsed = await parseResponse(response);
      const result = extractPayload(parsed);

      // Parsing logic: Handle result.Details.data (from screenshot) or result.data
      let dataArray = null;
      let total = 0;
      let overdueCount = 0;
      let completedCount = 0;
      let openCount = 0;

      if (result && result.Details && Array.isArray(result.Details)) {
        dataArray = result.Details;
        total = dataArray.length > 0 ? (dataArray[0].TotalRow || dataArray.length) : 0;
      } else if (result && result.Details && result.Details.data) {
        dataArray = result.Details.data;
        total = result.Details.totalRecords || result.Details.TotalCount || 0;
        overdueCount = result.Details.overdueCount || result.Details.OverdueCount || 0;
        completedCount = result.Details.completedCount || result.Details.CompletedCount || 0;
        openCount = result.Details.openCount || result.Details.OpenCount || 0;
      } else if (result && result.data) {
        dataArray = result.data;
        total = result.recordsTotal || 0;
        overdueCount = result.overdueCount || 0;
        completedCount = result.completedCount || 0;
        openCount = result.openCount || 0;
      } else if (Array.isArray(result)) {
        dataArray = result;
        total = result.length;
      }

      if (dataArray && dataArray.length) {
        const mappedTasks = dataArray.map(item => {
          const startDate = item.StartDate || item.startDate || item.startdate || "";
          const endDate = item.EndDate || item.endDate || item.enddate || "";
          const createdDate = item.CreatedOn || item.CreatedDate || item.createdon || item.DateCreated || "";
          const completedDate = item.CompletedDate || item.CompletedOn || item.completedon || item.ModifiedOn || item.modifiedon || item.ModifiedDate || item.ModifiedOn1 || item.ActualEndDate || item.CompletedOn_Date || item.CompletedOn_DateTime || item.CompletedOn_date || "";

          let titleDate = null;
          if (item.Title) {
            // Robust Title Date Extraction with strict validation
            const matchCompact = String(item.Title).match(/(\d{4})(\d{2})(\d{2})/);
            if (matchCompact) {
              const y = parseInt(matchCompact[1], 10);
              const m = parseInt(matchCompact[2], 10);
              const d = parseInt(matchCompact[3], 10);
              if (y >= 2000 && y <= 2100 && m >= 1 && m <= 12 && d >= 1 && d <= 31) {
                titleDate = `${y}-${String(m).padStart(2, '0')}-${String(d).padStart(2, '0')}`;
              }
            }
          }

          const hasValidStart = startDate && !startDate.startsWith('1900');
          const safeDateStr = hasValidStart ? startDate : (endDate || createdDate || "");

          let bestName = "-";
          if (item.PersonName && String(item.PersonName).trim() !== '' && String(item.PersonName).toLowerCase() !== 'unknown') {
            bestName = item.PersonName;
          } else if (item.personName && String(item.personName).trim() !== '' && String(item.personName).toLowerCase() !== 'unknown') {
            bestName = item.personName;
          } else if (item.personname && String(item.personname).trim() !== '' && String(item.personname).toLowerCase() !== 'unknown') {
            bestName = item.personname;
          } else if (item.RelatedTo && String(item.RelatedTo).trim() !== '') {
            bestName = item.RelatedTo;
          } else if (item.CsvMobileNo && String(item.CsvMobileNo).trim() !== '') {
            bestName = item.CsvMobileNo;
          }

          const finalCompDate = (typeof item.Completed === 'string' && item.Completed.length > 5) ? item.Completed : (completedDate || titleDate || (item.Status === 'Completed' ? item.ModifiedOn : ""));

          const cleanT = cleanTaskTitle(item.Title || item.taskTitle || 'No Title');

          return {
            ...item,
            id: item.TaskHistoryId || item.Id || item.id || item.TaskId || item.taskId || (Math.random() * 1000000),
            name: bestName !== "-" ? bestName : '-',
            taskTitle: cleanT,
            Title: cleanT,
            phone: item.CsvMobileNo || item.MobileNo || '',
            email: item.CsvEmailId || item.Email || '',
            enquiryId: item.LeadId ? item.LeadId.toString() : (item.EnquiryId ? item.EnquiryId.toString() : ''),
            status: item.TaskStatus || item.Status || 'Open',
            statusLabel: item.TaskStatus || item.Status || 'Open',
            ownerName: item.AgentName || item.OwnerName || item.CreatorName || '-',
            date: safeDateStr ? new Date(safeDateStr).toLocaleDateString('en-GB', { day: '2-digit', month: 'short' }) : '',
            createdDate: item.CreatedOn || item.CreatedDate || item.createdon || item.DateCreated || "",
            description: item.Description || '',
            startDate: startDate,
            endDate: endDate,
            creatorName: item.AgentName || item.CreatorName || '',
            assignedTo: item.AssignedTo || item.AgentName || '',
            taskStatus: item.TaskStatus || item.Status || 'Open',
            outcomeName: item.Outcome || item.OutcomeName || '',
            remarks: item.Remarks || '',
            statusLabel: item.TaskStatus || item.Status || 'Open',
            completedDate: finalCompDate,
            modifiedDate: item.ModifiedOn || item.modifiedon || item.ModifiedDate || item.CompletedOn || ""
          };
        });

        // Deduplicate in case backend returns duplicate rows during a search join
        const uniqueMap = new Map();
        mappedTasks.forEach(task => {
          if (!uniqueMap.has(task.id)) {
            uniqueMap.set(task.id, task);
          }
        });
        const deduplicatedTasks = Array.from(uniqueMap.values());

        setTasks(deduplicatedTasks);
        setTaskDetail(null);
        if (deduplicatedTasks.length > 0) {
          setSelectedTask(deduplicatedTasks[0]);
        } else {
          setSelectedTask(null);
        }
        
        // Keep the total records exactly as the API reports to prevent pagination jumping
        setTotalRecords(total);

        // We only fetch 25 items, so local counts are not accurate for the global dashboard.
        // We preserve the existing globalStats (which are fetched by fetchGlobalStats).
        setGlobalStats(prev => {
          const currentTotal = total;
          return {
            ...prev,
            total: prev.absoluteTotal || currentTotal,
            absoluteTotal: prev.absoluteTotal || currentTotal
          };
        });
      } else {
        setTasks([]);
        setTotalRecords(0);
        setSelectedTask(null);
        setTaskDetail(null);
      }
      setIsInitialLoad(false);
    } catch (error) {
      // Removed AbortError check
      console.error("Error fetching tasks:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleCustomSearchSubmit = (criteria) => {
    const cid = criteria?.ID || criteria?.Id || 0;
    setCustomSearchId(cid);
    // Use timeout to ensure state is set before triggering refresh
    setTimeout(() => fetchTasks(), 0);
  };

  const handleCustomSearchClear = () => {
    setCustomSearchId(0);
    setTimeout(() => fetchTasks(), 0);
  };

  useEffect(() => {
    fetchTasks();
  }, [debouncedSearchTerm, dashboardFilter, taskTabFilter, currentPage]);

  // Helper to parse date string "31-Oct-2025 10:11:14" or "06 Mar"
  const parseCustomDate = (dateStr) => {
    if (!dateStr || dateStr === "0" || dateStr === "null") return null;
    let cleanStr = String(dateStr).trim();

    if (cleanStr.includes('/Date(')) {
      try {
        const timestamp = parseInt(cleanStr.replace(/\/Date\((-?\d+)\)\//, '$1'), 10);
        const d = new Date(timestamp);
        return (isNaN(d.getTime()) || d.getFullYear() < 1900) ? null : d;
      } catch (e) { return null; }
    }

    try {
      // First try native Date (handles ISO strings best)
      const d = new Date(cleanStr.replace(' ', 'T'));
      if (!isNaN(d.getTime()) && d.getFullYear() >= 1900) return d;

      const months = { 'jan': 0, 'feb': 1, 'mar': 2, 'apr': 3, 'may': 4, 'jun': 5, 'jul': 6, 'aug': 7, 'sep': 8, 'oct': 9, 'nov': 10, 'dec': 11 };

      // Normalize: Treat space as separator and split
      const parts = cleanStr.split(/[\sT,]+/);
      if (parts.length === 0) return null;

      let day = 1, month = 0, year = new Date().getFullYear();
      let timeStr = "";

      // Case: "DD-MMM-YYYY" or "YYYY-MM-DD"
      const dateParts = parts[0].split(/[-/.]/);
      if (dateParts.length >= 2) {
        if (dateParts[0].length === 4) {
          year = parseInt(dateParts[0], 10);
          month = isNaN(dateParts[1]) ? months[dateParts[1].toLowerCase().substring(0, 3)] : parseInt(dateParts[1], 10) - 1;
          day = parseInt(dateParts[2], 10) || 1;
        } else {
          day = parseInt(dateParts[0], 10);
          month = isNaN(dateParts[1]) ? months[dateParts[1].toLowerCase().substring(0, 3)] : parseInt(dateParts[1], 10) - 1;
          if (dateParts[2]) year = dateParts[2].length === 2 ? 2000 + parseInt(dateParts[2], 10) : parseInt(dateParts[2], 10);
        }
        timeStr = parts[1] || "";
      }
      // Case: "DD MMM" or "DD MMM YYYY"
      else if (parts.length >= 2 && isNaN(parts[1])) {
        day = parseInt(parts[0], 10);
        month = months[parts[1].toLowerCase().substring(0, 3)] || 0;
        if (parts[2] && !isNaN(parts[2])) {
          year = parts[2].length === 2 ? 2000 + parseInt(parts[2], 10) : parseInt(parts[2], 10);
          timeStr = parts[3] || "";
        } else {
          timeStr = parts[2] || "";
        }
      } else {
        return null;
      }

      let hours = 0, minutes = 0, seconds = 0;
      if (timeStr) {
        const timeParts = timeStr.split(':');
        hours = parseInt(timeParts[0], 10) || 0;
        minutes = parseInt(timeParts[1], 10) || 0;
        seconds = parseInt(timeParts[2], 10) || 0;
      }

      const finalDate = new Date(year, month, day, hours, minutes, seconds);
      return (isNaN(finalDate.getTime()) || finalDate.getFullYear() < 1900) ? null : finalDate;
    } catch (e) {
      console.error("Date parsing error for:", dateStr, e);
      return null;
    }
  };

  const formatDisplayDate = (dateStr) => {
    if (!dateStr || dateStr === "0" || dateStr === "null" || String(dateStr).startsWith('1900')) return "--";
    const date = parseCustomDate(dateStr);
    if (!date) return String(dateStr);

    const day = String(date.getDate()).padStart(2, '0');
    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    const month = months[date.getMonth()];
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const seconds = String(date.getSeconds()).padStart(2, "0");

    return `${day}-${month}-${year} ${hours}:${minutes}`;
  };


  const formatDateTimeDisplay = (dateStr, timeStr) => {
    if (!dateStr || !timeStr) return "";
    try {
      const d = new Date(`${dateStr}T${timeStr}`);
      if (isNaN(d.getTime())) return "";
      const monthsAbbr = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
      return `${d.getDate().toString().padStart(2, '0')}-${monthsAbbr[d.getMonth()]}-${d.getFullYear()} ${timeStr}`;
    } catch (e) { return ""; }
  };

  const handleCombinedDateTimeChange = (e, setter, dateField, timeField) => {
    const { value } = e.target; // value is YYYY-MM-DDTHH:mm
    if (!value) return;
    const [date, time] = value.split('T');
    setter(prev => ({
      ...prev,
      [dateField]: date,
      [timeField]: time
    }));
  };

  const getLocalISO = () => {
    const now = new Date();
    const tzOffset = now.getTimezoneOffset() * 60000;
    return (new Date(now - tzOffset)).toISOString().slice(0, 16);
  };


  // Helper to determine if a task is overdue
  const isTaskOverdue = (task) => {
    const status = (task.status || '').toLowerCase().trim();
    const statusLabel = (task.statusLabel || '').toLowerCase().trim();
    const outcomeName = (task.outcomeName || '').toLowerCase().trim();

    const isCompleted = status === 'completed' || status === 'closed' ||
      statusLabel === 'completed' || statusLabel === 'closed' ||
      outcomeName === 'completed' || outcomeName === 'done' || outcomeName === 'closed';

    if (isCompleted) return false;

    // Use EndDate, fallback to StartDate
    const dateStr = task.endDate || task.startDate;
    if (!dateStr) return false;

    const targetDate = parseCustomDate(dateStr);
    if (!targetDate) return false;

    const now = new Date();
    // Compare timestamp
    return targetDate < now;
  };

  const getTaskCompletionBadge = (task) => {
    const status = (task.status || '').toLowerCase().trim();
    const statusLabel = (task.statusLabel || '').toLowerCase().trim();
    const outcomeName = (task.outcomeName || '').toLowerCase().trim();

    // Status and type flags
    const isCompleted = status === 'completed' || status === 'closed' ||
      statusLabel === 'completed' || statusLabel === 'closed' ||
      outcomeName === 'completed' || outcomeName === 'done' || outcomeName === 'closed';

    // Select valid due date 
    const rawDueDate = task.date || task.endDate || task.startDate || task.createdDate;
    const rawCompletedDate = task.completedDate;

    let dueDateCandidate = (rawDueDate && typeof rawDueDate === 'string' && !rawDueDate.startsWith('1900')) ? rawDueDate : null;
    let compDateCandidate = (rawCompletedDate && typeof rawCompletedDate === 'string' && !rawCompletedDate.startsWith('1900')) ? rawCompletedDate : null;

    // Final attempt at extraction if mapping failed
    if (!compDateCandidate && task.taskTitle) {
      const match = String(task.taskTitle).match(/(\d{4}-\d{2}-\d{2})/);
      if (match) compDateCandidate = match[1];
    }

    const isOverdue = status === 'overdue' || (dueDateCandidate && parseCustomDate(dueDateCandidate) < new Date() && !isCompleted);

    // Status badges logic
    if (isCompleted) {
      const now = new Date();
      now.setHours(0, 0, 0, 0);
      const dDate = dueDateCandidate ? parseCustomDate(dueDateCandidate) : null;
      if (dDate) {
        dDate.setHours(0, 0, 0, 0);
        const diffTime = now.getTime() - dDate.getTime();
        const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
        if (diffDays === 0) return <span className="status-badge-inline completed">Completed Today</span>;
        if (diffDays > 0) return <span className="status-badge-inline completed">Completed {diffDays} Day(s) After Due Date</span>;
        return <span className="status-badge-inline completed">Completed {Math.abs(diffDays)} Day(s) Before Due Date</span>;
      }
      return <span className="status-badge-inline completed">Completed</span>;
    }

    if (isOverdue) {
      const dDate = dueDateCandidate ? parseCustomDate(dueDateCandidate) : null;
      if (dDate) {
        const now = new Date();
        now.setHours(0, 0, 0, 0);
        dDate.setHours(0, 0, 0, 0);
        const diffDays = Math.ceil((now.getTime() - dDate.getTime()) / (1000 * 60 * 60 * 24));
        return <span className="status-badge-inline overdue">Overdue {Math.max(1, Math.abs(diffDays))} Day(s)</span>;
      }
      return <span className="status-badge-inline overdue">Overdue</span>;
    }

    return <span className="status-badge-inline open">OPEN</span>;
  };

  const getTaskStatusClass = (task) => {
    const status = (task.status || '').toLowerCase().trim();
    const statusLabel = (task.statusLabel || '').toLowerCase().trim();
    const outcomeName = (task.outcomeName || '').toLowerCase().trim();

    const isCompleted = status === 'completed' || status === 'closed' ||
      statusLabel === 'completed' || statusLabel === 'closed' ||
      outcomeName === 'completed' || outcomeName === 'done' || outcomeName === 'closed';

    const isValEnd = task.endDate && !task.endDate.startsWith('1900');
    const isValStart = task.startDate && !task.startDate.startsWith('1900');
    const dueDateStr = isValEnd ? task.endDate : (isValStart ? task.startDate : null);
    const isPastDue = dueDateStr && parseCustomDate(dueDateStr) < new Date() && !isCompleted;

    if (status === 'overdue' || isPastDue) return 'task-status-red';
    if (isCompleted) return 'task-status-green';
    return 'task-status-blue'; // Open
  };

  const handleFilterChange = (newFilters) => {
    setAdvancedFilters(newFilters);
    setCurrentPage(1);
  };

  // Reset pagination when taskTabFilter, search, or advanced filters change
  useEffect(() => {
    if (currentPage !== 1) {
      setCurrentPage(1);
    }
  }, [taskTabFilter, searchTerm, advancedFilters]);

  const filteredTasks = useMemo(() => {

    const filtered = tasks.filter(task => {
      // Tab filtering (Open, Completed, Overdue) is now handled server-side.
      const matchesFilter = true;
      const taskStatus = task.status ? String(task.status).toLowerCase().trim() : '';

      // Search Scope Expanded
      const searchVal = searchTerm.toLowerCase().trim();
      let matchesSearch = true;
      if (searchVal) {
        const nameMatch = String(task.name || task.RelatedTo || task.PersonName || "").toLowerCase().includes(searchVal);
        const titleMatch = String(task.taskTitle || task.Title || task.title || "").toLowerCase().includes(searchVal);
        matchesSearch = nameMatch || titleMatch;
      }

      // --- ADVANCED FILTERS ---
      let matchesAdvanced = true;
      if (advancedFilters) {
        // If the new dynamic structure is present (logic + rows)
        if (advancedFilters.searchRows && Array.isArray(advancedFilters.searchRows)) {
          const { applyLogic: logic, searchRows: rows } = advancedFilters;
          if (rows.length > 0) {
            const rowMatches = rows.map(row => {
              const searchVal = String(row.value || '').toLowerCase().trim();
              if (!searchVal) return true;

              let valuesToCheck = [];
              const primaryVal = task[row.field];
              if (primaryVal !== undefined && primaryVal !== null) {
                valuesToCheck.push(String(primaryVal).toLowerCase().trim());
              }

              // Fallbacks for common field names
              if (row.field === 'name' || row.field === 'LeadName' || row.field === 'PersonName') {
                if (task.name) valuesToCheck.push(String(task.name).toLowerCase().trim());
                if (task.PersonName) valuesToCheck.push(String(task.PersonName).toLowerCase().trim());
              } else if (row.field === 'taskTitle' || row.field === 'Title' || row.field === 'Subject') {
                if (task.taskTitle) valuesToCheck.push(String(task.taskTitle).toLowerCase().trim());
                if (task.Title) valuesToCheck.push(String(task.Title).toLowerCase().trim());
                if (task.Subject) valuesToCheck.push(String(task.Subject).toLowerCase().trim());
              } else if (row.field === 'ownerName' || row.field === 'AgentName') {
                if (task.ownerName) valuesToCheck.push(String(task.ownerName).toLowerCase().trim());
                if (task.AgentName) valuesToCheck.push(String(task.AgentName).toLowerCase().trim());
              } else if (row.field === 'statusLabel' || row.field === 'Status') {
                if (task.statusLabel) valuesToCheck.push(String(task.statusLabel).toLowerCase().trim());
                if (task.StatusLabel) valuesToCheck.push(String(task.StatusLabel).toLowerCase().trim());
              }

              const fieldMeta = taskFields.find(f => f.value === row.field);
              const isDateField = fieldMeta?.type === 'date' || row.field === 'endDate' || row.field === 'createdDate';

              return valuesToCheck.some(val => {
                if (isDateField) {
                  const taskDate = parseCustomDate(val);
                  const filterDate = new Date(row.value);

                  if (!taskDate || isNaN(filterDate.getTime())) return false;

                  // Compare dates (year, month, day only)
                  const tY = taskDate.getFullYear();
                  const tM = taskDate.getMonth();
                  const tD = taskDate.getDate();
                  const fY = filterDate.getFullYear();
                  const fM = filterDate.getMonth();
                  const fD = filterDate.getDate();

                  switch (row.operator) {
                    case 'equals': return tY === fY && tM === fM && tD === fD;
                    case 'not_equal': return !(tY === fY && tM === fM && tD === fD);
                    default: return tY === fY && tM === fM && tD === fD;
                  }
                }

                switch (row.operator) {
                  case 'equals': return val === searchVal;
                  case 'not_equal': return val !== searchVal;
                  case 'starts_with': return val.startsWith(searchVal);
                  case 'ends_with': return val.endsWith(searchVal);
                  case 'contains': return val.includes(searchVal);
                  case 'not_contains': return !val.includes(searchVal);
                  default: return val.includes(searchVal);
                }
              });
            });

            if (logic === 'ALL') {
              matchesAdvanced = rowMatches.every(m => m);
            } else {
              matchesAdvanced = rowMatches.some(m => m);
            }
          }
        } else {
          // Legacy/Fallback static filters support
          if (advancedFilters.statusFilter) {
            if (taskStatus !== advancedFilters.statusFilter.toLowerCase()) matchesAdvanced = false;
          }

          if (advancedFilters.outcomeFilter && matchesAdvanced) {
            const taskOutcome = task.outcomeName ? task.outcomeName.toLowerCase().replace(/\s/g, '') : '';
            const filterOutcome = advancedFilters.outcomeFilter.toLowerCase().replace(/_/g, '');
            if (!taskOutcome.includes(filterOutcome)) matchesAdvanced = false;
          }

          if (advancedFilters.dateFilter && matchesAdvanced) {
            // Simplified date fallback
            if (advancedFilters.dateFilter === 'overdue' && !isTaskOverdue(task)) matchesAdvanced = false;
          }
        }
      }

      return matchesFilter && matchesSearch && matchesAdvanced;
    });

    // --- SORTING ---
    let finalResult = [...filtered];
    if (advancedFilters && advancedFilters.sortBy) {
      finalResult.sort((a, b) => {
        const sortBy = advancedFilters.sortBy;
        if (sortBy === 'date_desc' || sortBy === 'created_desc') {
          return (parseCustomDate(b.createdDate)?.getTime() || 0) - (parseCustomDate(a.createdDate)?.getTime() || 0);
        }
        if (sortBy === 'date_asc' || sortBy === 'created_asc') {
          return (parseCustomDate(a.createdDate)?.getTime() || 0) - (parseCustomDate(b.createdDate)?.getTime() || 0);
        }
        if (sortBy === 'modified_desc') {
          const aMod = a.modifiedDate || a.createdDate;
          const bMod = b.modifiedDate || b.createdDate;
          return (parseCustomDate(bMod)?.getTime() || 0) - (parseCustomDate(aMod)?.getTime() || 0);
        }
        if (sortBy === 'modified_asc') {
          const aMod = a.modifiedDate || a.createdDate;
          const bMod = b.modifiedDate || b.createdDate;
          return (parseCustomDate(aMod)?.getTime() || 0) - (parseCustomDate(bMod)?.getTime() || 0);
        }
        if (sortBy === 'owner_asc') {
          return (a.creatorName || '').localeCompare(b.creatorName || '');
        }
        if (sortBy === 'owner_desc') {
          return (b.creatorName || '').localeCompare(a.creatorName || '');
        }
        return 0;
      });
    }
    // No default local sort: keep the order exactly as received from the API response

    return finalResult;
  }, [tasks, taskTabFilter, searchTerm, JSON.stringify(advancedFilters)]);

  // Reset selection on search to ensure details panel refreshes with the top result
  useEffect(() => {
    if (searchTerm) {
      setSelectedTask(null);
    }
  }, [searchTerm]);

  // Sync selection with filtered list
  useEffect(() => {
    if (selectedTask && !filteredTasks.some(t => t.id === selectedTask.id)) {
      setSelectedTask(null);
      setTaskDetail(null);
    }
  }, [filteredTasks, selectedTask]);

  // Auto-select first task if none selected and list has data
  useEffect(() => {
    if (!selectedTask && filteredTasks.length > 0 && !(loading || isInitialLoad)) {
      setSelectedTask(filteredTasks[0]);
    }
  }, [filteredTasks, selectedTask, loading, isInitialLoad]);

  // Smart Pagination Helper
  const getPaginationRange = (current, total) => {
    const delta = 2; // Number of pages to show around current
    const range = [];
    const rangeWithDots = [];

    for (let i = 1; i <= total; i++) {
      if (i === 1 || i === total || (i >= current - delta && i <= current + delta)) {
        range.push(i);
      }
    }

    let l;
    for (let i of range) {
      if (l) {
        if (i - l === 2) {
          rangeWithDots.push(l + 1);
        } else if (i - l !== 1) {
          rangeWithDots.push('...');
        }
      }
      rangeWithDots.push(i);
      l = i;
    }
    return rangeWithDots;
  };

  // Pagination Logic
  const totalPages = Math.ceil(totalRecords / itemsPerPage);
  const currentViewData = filteredTasks; // Data is already paginated by the API

  const handlePageChange = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
    }
  };


  const formatSidebarDate = (dateStr) => {
    if (!dateStr || dateStr === "0" || dateStr === "null" || String(dateStr).startsWith('1900')) return "--";
    const date = parseCustomDate(dateStr);
    if (!date) return String(dateStr);

    const day = String(date.getDate()).padStart(2, '0');
    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    const month = months[date.getMonth()];
    const year = date.getFullYear();

    return `${day}-${month}-${year}`;
  };

  const renderCalendarEvent = (event) => {
    const taskStatus = (event.TaskStatus || event.status || 'Open').toLowerCase();
    const isCompleted = taskStatus === 'completed' || taskStatus === 'closed';
    const dueDate = event.endDate || event.date || "";
    const dueDateObj = dueDate ? new Date(dueDate) : null;
    const today = new Date().setHours(0, 0, 0, 0);
    const isOverdue = !isCompleted && dueDateObj && dueDateObj < today;
    const isUpcoming = !isCompleted && !isOverdue && dueDateObj;

    let statusType = 'open';
    let statusLabel = 'OPEN';
    if (isCompleted) {
      statusType = 'completed';
      statusLabel = 'COMPLETED';
    } else if (isOverdue) {
      statusType = 'overdue';
      statusLabel = 'OVER DUE';
    } else if (isUpcoming) {
      statusType = 'upcoming';
      statusLabel = 'UPCOMING';
    }

    const cleanTitle = cleanTaskTitle(event.title || event.taskTitle || 'No Title');
    const isMonthlyView = calendarView === 'month';

    return (
      <div
        key={event.id}
        className={`calendar-card-modern ${statusType} ${isMonthlyView ? 'monthly-compact' : ''}`}
        onClick={(e) => { e.stopPropagation(); handleCalendarEventClick(event); }}
      >
        <div
          className="calendar-card-title link-style"
          title={cleanTitle}
          onClick={(e) => { e.stopPropagation(); handleCalendarEventClick(event); }}
        >
          {cleanTitle}
        </div>
        <div className="calendar-card-footer">
          <div className="calendar-footer-profiles">
            <div
              className="calendar-profile-item clickable-lead-link hyperlink"
              title={`Related: ${event.name}`}
              onClick={(e) => {
                e.stopPropagation();
                if (event.enquiryId) {
                  setViewingLeadId(event.enquiryId);
                  setViewingDetailTask(null);
                }
              }}
            >
              <div className="calendar-avatar-mini">{getInitials(event.name)}</div>
              <span className="calendar-user-name-mini link-style">{event.name}</span>
            </div>
            <div className="calendar-profile-item owner" title={`Owner: ${event.ownerName}`}>
              <div className="calendar-avatar-mini outline-icon">
                <User size={12} strokeWidth={2.5} />
              </div>
              <span className="calendar-user-name-mini">{event.ownerName}</span>
            </div>
          </div>
        </div>
      </div>
    );
  };

  // Handle event click from calendar
  const handleCalendarEventClick = (event) => {
    // Find the full task object from the event id
    const task = tasks.find(t => (t.TaskHistoryId || t.id) === event.id);
    if (task) {
      setViewingDetailTask(task);
      setDetailMode('view');
    } else if (event) {
      setViewingDetailTask(event);
      setDetailMode('view');
    }
  };

  if (crmOperationPerms && crmOperationPerms.View === false) {
    return (
      <div className="task-module-root" style={{ width: '100%', height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#f8fafc' }}>
        <div style={{ background: 'white', padding: '40px', borderRadius: '12px', boxShadow: '0 4px 20px rgba(0,0,0,0.08)', textAlign: 'center', maxWidth: '400px' }}>
          <div style={{ width: '64px', height: '64px', background: '#fee2e2', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 24px' }}>
            <X size={32} color="#ef4444" />
          </div>
          <h2 style={{ fontSize: '24px', fontWeight: 'bold', color: '#1e293b', marginBottom: '16px' }}>Access Denied</h2>
          <p style={{ color: '#64748b', marginBottom: '32px', lineHeight: '1.5' }}>
            You do not have permission to view the Task Module. Please contact your administrator if you believe this is a mistake.
          </p>
          <div style={{ display: 'flex', gap: '16px', justifyContent: 'center' }}>
            <button 
              onClick={() => navigate('/dashboard')} 
              style={{ padding: '10px 20px', background: '#f1f5f9', color: '#475569', border: 'none', borderRadius: '6px', cursor: 'pointer', fontWeight: '500' }}
            >
              Dashboard
            </button>
            <button 
              onClick={() => { localStorage.clear(); navigate('/'); }} 
              style={{ padding: '10px 20px', background: '#3b82f6', color: 'white', border: 'none', borderRadius: '6px', cursor: 'pointer', fontWeight: '500' }}
            >
              Logout
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="task-module-root" style={{ width: '100%', height: '100vh', overflow: 'hidden', display: 'flex', flexDirection: 'column', backgroundColor: '#f8f9fa' }}>
      <div className="app-fluid-container" style={{ width: '100%', padding: 0, boxSizing: 'border-box', display: 'flex', flexDirection: 'column', flex: 1, overflow: 'hidden' }}>
        {/* Custom Download Modal */}
        {isCustomDownloadOpen && (
          <div id="customDownloadOverlay">
            <div id="customDownloadPanel">
              <div className="custom-download-header">
                <h3>Custom Download</h3>
                <button className="close-panel-btn" onClick={() => setIsCustomDownloadOpen(false)}>&times;</button>
              </div>
              <div className="custom-download-body">
                <div className="setting-select-row">
                  <select
                    className="setting-dropdown"
                    value={selectedCustomSetting}
                    onChange={(e) => {
                      const sid = e.target.value;
                      setSelectedCustomSetting(sid);
                      const s = customSettings.find(st => st.Id.toString() === sid);
                      if (s && s.CsvColumns) setSelectedExportFields(s.CsvColumns.split(','));
                      else setSelectedExportFields([]);
                    }}
                  >
                    <option value="">Select Save Setting</option>
                    {customSettings.map(s => <option key={s.Id} value={s.Id}>{s.SettingName}</option>)}
                  </select>
                </div>
                <div className="field-search-box">
                  <input
                    type="text" placeholder="Search fields..." className="field-search-input"
                    value={fieldSearchTerm} onChange={(e) => setFieldSearchTerm(e.target.value)}
                  />
                </div>
                <div className="fields-list">
                  {customExportFields
                    .filter(f => f.ExposedName.toLowerCase().includes(fieldSearchTerm.toLowerCase()))
                    .map((f, i) => (
                      <label key={i} className="field-item">
                        <input
                          type="checkbox"
                          checked={selectedExportFields.includes(f.ExposedName)}
                          onChange={() => {
                            setSelectedExportFields(prev =>
                              prev.includes(f.ExposedName) ? prev.filter(x => x !== f.ExposedName) : [...prev, f.ExposedName]
                            );
                          }}
                        />
                        <span className="field-name">{f.ExposedName}</span>
                      </label>
                    ))}
                </div>
                <div className="save-setting-row">
                  <input
                    type="text" placeholder="Save Setting" className="save-setting-input"
                    value={exportSettingName} onChange={(e) => setExportSettingName(e.target.value)}
                  />
                  <button className="save-btn" onClick={handleSaveExportSetting}>Save Setting</button>
                </div>
              </div>
              <div className="custom-download-footer">
                <button className="final-download-btn" onClick={handleCustomDownloadSubmit} disabled={isDownloading}>
                  {isDownloading ? 'Processing...' : 'Download'}
                </button>
              </div>
            </div>
          </div>
        )}

        {/* --- Header Controls --- */}
        <TaskHeader
          searchQuery={searchTerm}
          setSearchQuery={setSearchTerm}
          totalTasks={filteredTasks.length}
          viewMode={viewMode}
          setViewMode={setViewMode}
          selectedCount={selectedCount}
          onClearSelection={() => {
            setRowSelection({});
            setIsAllSelectedAcrossPages(false);
            setAllIds([]);
          }}
          isAllSelectedAcrossPages={isAllSelectedAcrossPages}
          setIsAllSelectedAcrossPages={setIsAllSelectedAcrossPages}
          onMassAction={handleMassAction}
          advanceFilterFields={taskFields}
          onAdvanceFilterSubmit={crmOperationPerms?.Search ? handleAdvancedFilterSubmit : null}
          onCustomSearchSubmit={crmOperationPerms?.Search ? handleCustomSearchSubmit : null}
          onCustomSearchClear={handleCustomSearchClear}
          onExport={crmOperationPerms?.Export ? handleExportTasks : null}
          onCustomDownload={crmOperationPerms?.Export ? () => setIsCustomDownloadOpen(true) : null}
          onAddTask={crmOperationPerms?.Add ? () => setShowAddTaskModal(true) : null}
          showSearch={!!crmOperationPerms?.Search}
          showAdvanceFilter={!!crmOperationPerms?.Search}
          showCustomSearch={!!crmOperationPerms?.Search}
          sortBy={advancedFilters?.sortBy || 'created_desc'}
          onSortChange={handleSortChange}
        />

        {/* Mass Update Sticky Selection Bar removed in favor of header-based MassOperationPanel */}

        {/* Mass Update Sticky Selection Bar removed in favor of centralized MassOperationPanel */}

        {/* --- Filter Counter Cards (Parity with Appointment Module) --- */}
        {(viewMode === 'table' || viewMode === 'grid') && !viewingLeadId && (
          <div className="stats-cards-row" style={{ width: '100%', marginBottom: '20px', background: '#fff', position: 'relative', zIndex: 50, overflow: 'visible' }}>
            <PremiumModuleCards
              stats={globalStats}
              onStatusClick={handleStatusFilterClick}
              moduleName="Task"
              activeFilters={taskTabFilter}
            />
          </div>
        )}

        {/* Dashboard filter indicator */}
        {!viewingLeadId && location.search && location.state?.filterLabel && (
          <div style={{ padding: '8px 24px', background: '#eff6ff', borderBottom: '1px solid #bfdbfe' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '13px', fontWeight: '600', color: '#1e40af' }}>
              <Filter size={14} />
              <span>Filtered by Dashboard: {location.state.filterLabel}</span>
              <button
                onClick={clearDashboardFilter}
                className="clear-filter-circle"
                style={{ 
                  background: '#dbeafe', border: 'none', borderRadius: '50%', 
                  width: '20px', height: '20px', display: 'flex', alignItems: 'center', 
                  justifyContent: 'center', cursor: 'pointer', color: '#1e3a8a', padding: 0, marginLeft: '4px' 
                }}
              >
                <Plus size={14} style={{ transform: 'rotate(45deg)' }} />
              </button>
            </div>
          </div>
        )}

        {/* Existing Task List Body */}
        <div className="content-layout" style={{ width: '100%', maxWidth: '100%', padding: 0, margin: 0, boxSizing: 'border-box', flex: 1, display: 'flex', flexDirection: 'row', overflow: 'hidden', position: 'relative' }}>
          {viewingLeadId ? (
            <CommonLeadDetails leadId={viewingLeadId} onBack={() => setViewingLeadId(null)} module="task" maskObject={maskObject} isHiddenField={isHiddenField} />
          ) : (
            <>

              {viewMode === 'grid' && !viewingLeadId && (
                <GridMainPanelLayout
                  type="task"
                  data={currentViewData}
                  loading={loading || isInitialLoad}
                  totalRecords={searchTerm ? filteredTasks.length : totalRecords}
                  currentPage={currentPage}
                  totalPages={totalPages}
                  onPageChange={handlePageChange}
                  selectedItem={selectedTask}
                  onSelectItem={setSelectedTask}
                  rowSelection={rowSelection}
                  onRowSelectionChange={handleRowSelectionChange}
                  onViewLead={setViewingLeadId}
                  getCompletionBadge={getTaskCompletionBadge}
                  formatDate={formatSidebarDate}
                  getInitials={getInitials}
                  hideSelection={!crmOperationPerms?.MassUpdate && !crmOperationPerms?.MassDelete && !crmOperationPerms?.MassSMS && !crmOperationPerms?.MassEmail && !crmOperationPerms?.MassAssign && !crmOperationPerms?.MassBroadcast}
                />
              )}


              {viewMode === 'table' && (
                <div className="table-view-container" style={{ width: '100%', flex: 1, display: 'flex', flexDirection: 'column', overflow: 'visible' }}>
                  <TaskListWrapper
                    hideSelection={!crmOperationPerms?.MassUpdate && !crmOperationPerms?.MassDelete && !crmOperationPerms?.MassSMS && !crmOperationPerms?.MassEmail && !crmOperationPerms?.MassAssign && !crmOperationPerms?.MassBroadcast}
                    crmOperationPerms={crmOperationPerms}
                    isHiddenField={isHiddenField}
                    data={currentViewData.map(t => {
                      const task = maskObject(t);

                      const taskStatus = (task.TaskStatus || task.status || 'Open').toLowerCase();
                      const isCompleted = taskStatus === 'completed' || taskStatus === 'closed';
                      const dueDate = task.endDate || task.date || task.createdDate || "";
                      const isOverdue = !isCompleted && dueDate && new Date(dueDate) < new Date();

                      let statusLabel = 'Open';
                      if (isCompleted) statusLabel = 'Completed';
                      else if (isOverdue) statusLabel = 'Overdue';

                      // Ensure title is cleaned here too
                      const cleanTitle = cleanTaskTitle(task.taskTitle || task.Title || 'No Title');

                      return {
                        ...task,
                        id: task.TaskHistoryId || task.id,
                        title: cleanTitle,
                        taskTitle: cleanTitle,
                        issuedDate: task.createdDate || '',
                        dueDate: task.endDate || task.date || '',
                        status: statusLabel,
                        relatedTo: task.name || task.RelatedTo || 'Unknown',
                        owner: task.creatorName || task.assignedTo || 'Unassigned',
                        avatar: task.avatar || '',
                        phone: task.phone || '',
                        leadNo: task.enquiryId || '',
                        enquiryId: task.enquiryId || ''
                      }
                    })}
                    loading={loading || isInitialLoad}
                    totalRecords={searchTerm ? filteredTasks.length : totalRecords}
                    stats={globalStats?.total > 0 ? globalStats : null}
                    currentPage={currentPage}
                    itemsPerPage={itemsPerPage}
                    onStatusChange={handleStatusFilterClick}
                    activeFilters={taskTabFilter}
                    onPageChange={(newPage) => setCurrentPage(newPage)}
                    onAddTask={crmOperationPerms?.Add ? () => setShowAddTaskModal(true) : null}
                    onEditTask={crmOperationPerms?.Edit ? (task) => {
                      handleEditTaskClick(task.id);
                    } : null}
                    onDeleteTask={crmOperationPerms?.Delete ? (task) => {
                      handleDeleteTask(task.id);
                    } : null}
                    onRowSelectionChange={handleRowSelectionChange}
                    onManualRowSelectionChange={handleRowSelectionChange}
                    rowSelection={rowSelection}
                    onSelectAll={() => {
                      const newSel = {};
                      filteredTasks.forEach(t => {
                        newSel[t.TaskHistoryId || t.id] = true;
                      });
                      setRowSelection(newSel);
                    }}
                    onViewTask={(task, mode = 'view') => {
                      const originalTask = filteredTasks.find(t => (t.TaskHistoryId || t.id) === task.id);
                      if (originalTask) {
                        if (mode === 'comment') {
                          setTaskForComment(originalTask);
                          setCommentText('');
                          setCommentFile(null);
                          setCommentFileName('');
                          setShowCommentModal(true);
                        } else {
                          setViewingDetailTask(originalTask);
                          setDetailMode(mode);
                        }
                      }
                    }}
                    onViewLead={handleViewLead}
                    onMarkAsCompleted={handleMarkAsCompleted}
                    onRefresh={fetchTasks}
                    isInitialLoad={isInitialLoad}
                    searchTerm={searchTerm}
                  />
                </div>
              )}

              {viewMode === 'calendar' && (
                <div className="calendar-view-wrapper" style={{ position: 'relative', width: '100%', height: '100%', flex: 1, backgroundColor: '#fff' }}>
                  {(loading || isInitialLoad) && (
                    <div style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, zIndex: 10, backgroundColor: 'rgba(255,255,255,0.7)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                      <Loader message="Loading calendar..." />
                    </div>
                  )}
                  <DynamicCalendar
                    headerLegend={
                      <Stack direction="row" spacing={2.5} sx={{ mt: 1.5, flexWrap: 'wrap', gap: '12px' }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                          <Box sx={{ width: 10, height: 10, borderRadius: '50%', bgcolor: '#2563eb' }} />
                          <Typography sx={{ fontSize: '13px', fontWeight: 600, color: '#475569' }}>Open</Typography>
                        </Box>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                          <Box sx={{ width: 10, height: 10, borderRadius: '50%', bgcolor: '#f97316' }} />
                          <Typography sx={{ fontSize: '13px', fontWeight: 600, color: '#475569' }}>Upcoming</Typography>
                        </Box>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                          <Box sx={{ width: 10, height: 10, borderRadius: '50%', bgcolor: '#ef4444' }} />
                          <Typography sx={{ fontSize: '13px', fontWeight: 600, color: '#475569' }}>Overdue</Typography>
                        </Box>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                          <Box sx={{ width: 10, height: 10, borderRadius: '50%', bgcolor: '#10b981' }} />
                          <Typography sx={{ fontSize: '13px', fontWeight: 600, color: '#475569' }}>Completed</Typography>
                        </Box>
                      </Stack>
                    }
                    events={filteredTasks.map(task => {
                      const taskStatus = (task.TaskStatus || task.status || 'Open').toLowerCase();
                      const isCompleted = taskStatus === 'completed' || taskStatus === 'closed';
                      const dueDateStr = task.endDate || task.date || "";
                      const dueDate = dueDateStr ? new Date(dueDateStr) : null;
                      const today = new Date().setHours(0, 0, 0, 0);
                      const isOverdue = !isCompleted && dueDate && dueDate < today;
                      const isUpcoming = !isCompleted && !isOverdue && dueDate;

                      let computedStatus = 'open';
                      if (isCompleted) computedStatus = 'completed';
                      else if (isOverdue) computedStatus = 'overdue';
                      else if (isUpcoming) computedStatus = 'upcoming';

                      return {
                        ...task,
                        id: task.TaskHistoryId || task.id,
                        title: task.taskTitle,
                        date: parseCustomDate(task.endDate || task.date || task.startDate) || new Date(),
                        status: task.status,
                        computedStatus,
                        name: task.name,
                        ownerName: task.AgentName || task.creatorName || task.assignedTo
                      };
                    })}
                    eventRenderer={renderCalendarEvent}
                    onEventClick={handleCalendarEventClick}
                    onDateChange={(date, view) => setCalendarView(view)}
                    initialView="month"
                    initialDate={new Date()}
                  />
                </div>
              )}
            </>
          )}
        </div>
        {viewingDetailTask && (
          detailMode === 'view' ? (
            <AppointmentTaskDetailPanel
              isOpen={!!viewingDetailTask}
              onClose={() => setViewingDetailTask(null)}
              id={viewingDetailTask.TaskHistoryId || viewingDetailTask.id}
              onRefresh={fetchTasks}
              type="task"
              detailData={viewingDetailTask}
            />
          ) : (
            <Panels
              isOpen={!!viewingDetailTask}
              onClose={() => setViewingDetailTask(null)}
              backTitle="Task"
              width="50%"
              title={
                detailMode === 'edit' ? 'Edit Task' :
                  detailMode === 'view' ? 'Task Details' :
                    (detailMode === 'sms' || detailMode === 'send-sms') ? 'Send SMS' :
                      (detailMode === 'mail' || detailMode === 'send-mail') ? 'Send Mail' :
                        (detailMode === 'voice' || detailMode === 'send-voice') ? 'Send Voice' :
                          (detailMode === 'followup' || detailMode === 'followup-premium') ? 'Add Followup' :
                            (detailMode === 'notes' || detailMode === 'add-notes') ? 'Add Notes' :
                              (detailMode === 'upload' || detailMode === 'upload-document') ? 'Upload Document' : 'Task Action'
              }
            >
              <LeadActionOperation
                crmOperationPerms={crmOperationPerms}
                entity={viewingDetailTask}
                mode={detailMode}
                onBack={() => setViewingDetailTask(null)}
                onSuccess={() => {
                  setViewingDetailTask(null);
                  fetchTasks();
                }}
              />
            </Panels>
          )
        )}

        <Panels
          isOpen={showAddTaskModal}
          onClose={() => setShowAddTaskModal(false)}
          backTitle="Task"
          title="Task"
          width="50%"
        >
          <div className="drawer-body">
            <h2 className="drawer-title">Add Task</h2>

            <div className="task-form-group">
              <label className="task-form-label">Title *</label>
              <input
                type="text"
                className="task-form-control"
                placeholder="Enter Title"
                value={addTaskData.Title}
                onChange={(e) => setAddTaskData({ ...addTaskData, Title: e.target.value })}
              />
            </div>

            <div className="task-form-group">
              <label className="task-form-label">Description</label>
              <textarea
                className="task-form-control"
                placeholder="Start Typing the details about the task..."
                value={addTaskData.Description}
                onChange={(e) => setAddTaskData({ ...addTaskData, Description: e.target.value })}
                style={{ minHeight: '100px' }}
              />
            </div>

            <div className="task-row-group">
              <div className="task-form-group third-width">
                <label className="task-form-label">Task Type</label>
                <select
                  className="task-form-control"
                  value={addTaskData.TaskType}
                  onChange={(e) => setAddTaskData({ ...addTaskData, TaskType: e.target.value })}
                >
                  <option value="">Select Task Type</option>
                  {taskTypeOptions.map(opt => (
                    <option key={opt.TasKId || opt.Id} value={opt.TasKId || opt.Id}>{opt.TasKName}</option>
                  ))}
                </select>
              </div>

              <div className="task-form-group third-width">
                <label className="task-form-label">Due Date and Time *</label>
                <div className="premium-datetime-container" onClick={(e) => e.currentTarget.querySelector('input').showPicker()}>
                  <Calendar size={18} className="datetime-icon" />
                  <div className="premium-datetime-value">
                    {formatDateTimeDisplay(addTaskData.DueDate, addTaskData.DueTime)}
                  </div>
                  <input
                    type="datetime-local"
                    value={`${addTaskData.DueDate}T${addTaskData.DueTime}`}
                    min={getLocalISO()}
                    onChange={(e) => handleCombinedDateTimeChange(e, setAddTaskData, 'DueDate', 'DueTime')}
                    className="hidden-datetime-input"
                  />
                </div>
              </div>

              <div className="task-form-group third-width">
                <label className="task-form-label">Related To</label>
                <div className="related-input-wrapper" ref={relatedRef}>
                  <div className="related-search-container">
                    {!relatedSelected && (
                      <input
                        type="text"
                        className="task-form-control"
                        placeholder="Type Task name or Mobile or Company"
                        value={relatedSearch}
                        onChange={(e) => {
                          setRelatedSearch(e.target.value);
                          setShowRelatedDropdown(true);
                        }}
                        onFocus={() => {
                          if (relatedSearch.length >= 2) setShowRelatedDropdown(true);
                        }}
                      />
                    )}
                    {relatedSelected && (
                      <div className="selected-lead-internal-chip">
                        <span className="selected-lead-name">
                          {relatedSelected.PersonName || relatedSelected.Name || relatedSelected.RelatedTo || 'Selected'}
                        </span>
                        <button className="remove-lead-btn" onClick={() => setRelatedSelected(null)}>✕</button>
                      </div>
                    )}
                  </div>
                  {showRelatedDropdown && relatedSuggestions.length > 0 && (
                    <ul className="related-suggestions-list">
                      {relatedSuggestions.map((s, i) => (
                        <li key={i} onClick={() => {
                          setRelatedSelected(s);
                          setRelatedSearch('');
                          setShowRelatedDropdown(false);
                        }}>
                          <span className="lead-name">{s.PersonName || s.Name || s.RelatedTo || s.Text || s.text}</span>
                          <span className="lead-phone">{s.PersonalMobileNo || s.MobileNo || s.CsvMobileNo}</span>
                        </li>
                      ))}
                    </ul>
                  )}
                  <small className="related-helper" style={{ fontSize: '10px', color: '#94a3b8' }}>(From Lead Section)</small>
                </div>
              </div>
            </div>

            <div className="task-row-group">
              <div className="task-form-group half-width">
                <label className="task-form-label">Owner</label>
                <select
                  className="task-form-control"
                  value={addTaskData.Owner}
                  onChange={(e) => setAddTaskData({ ...addTaskData, Owner: e.target.value })}
                >
                  {ownerOptions.map(opt => (
                    <option key={opt.Code} value={opt.Code}>{opt.Text}</option>
                  ))}
                </select>
              </div>

              <div className="task-form-group half-width">
                <label className="task-form-label">Collaborators</label>
                <div className="collaborator-select-wrapper" ref={collabRef}>
                  <div
                    className="collab-display"
                    onClick={(e) => { e.stopPropagation(); setShowCollabDropdown(prev => !prev); }}
                  >
                    {addTaskData.Collaborators && addTaskData.Collaborators.split(',').filter(x => x).length > 0 ? (
                      addTaskData.Collaborators.split(',').filter(x => x).map(id => {
                        const collab = collaboratorOptions.find(c => String(c.Code) === id);
                        return collab ? (
                          <div key={id} className="collaborator-chip">
                            <span>{collab.Text}</span>
                            <X
                              size={14}
                              className="remove-collab"
                              onClick={(e) => {
                                e.stopPropagation();
                                const next = addTaskData.Collaborators.split(',').filter(x => x && x !== id);
                                setAddTaskData({ ...addTaskData, Collaborators: next.join(',') });
                              }}
                            />
                          </div>
                        ) : null;
                      })
                    ) : (
                      <span className="collab-placeholder">Select Collaborators</span>
                    )}
                    <div style={{ flex: 1 }}></div>
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#94a3b8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ transition: 'transform 0.2s ease', transform: showCollabDropdown ? 'rotate(180deg)' : 'rotate(0deg)', flexShrink: 0 }}><polyline points="6 9 12 15 18 9" /></svg>
                  </div>
                  {showCollabDropdown && (
                    <Popper
                      open={showCollabDropdown}
                      anchorEl={collabRef.current}
                      placement="bottom-start"
                      modifiers={[
                        { name: 'flip', enabled: false },
                        { name: 'preventOverflow', enabled: true, options: { boundary: 'viewport' } }
                      ]}
                      style={{ zIndex: 100001, width: collabRef.current?.offsetWidth }}
                    >
                      <div className="collab-dropdown-menu" onClick={(e) => e.stopPropagation()} style={{ width: '100%' }}>
                        <div className="collab-dropdown-header">
                          <span className="collab-dropdown-title">Collaborators</span>
                          <button
                            className="collab-dropdown-close"
                            onClick={(e) => { e.stopPropagation(); setShowCollabDropdown(false); setCollabSearch(''); }}
                          >
                            <X size={15} />
                          </button>
                        </div>
                        <input
                          type="text"
                          className="collab-search"
                          placeholder="Search..."
                          value={collabSearch}
                          onChange={(e) => setCollabSearch(e.target.value)}
                          onClick={(e) => e.stopPropagation()}
                        />
                        <div className="collab-options-list">
                          {collaboratorOptions.filter(c => (c.Text || '').toLowerCase().includes(collabSearch.toLowerCase())).map(c => (
                            <label key={c.Code} className="collab-option" onClick={(e) => e.stopPropagation()}>
                              <input
                                type="checkbox"
                                checked={addTaskData.Collaborators.split(',').includes(String(c.Code))}
                                onChange={(e) => {
                                  const current = addTaskData.Collaborators ? addTaskData.Collaborators.split(',').filter(x => x) : [];
                                  let next;
                                  if (e.target.checked) next = [...current, String(c.Code)];
                                  else next = current.filter(id => id !== String(c.Code));
                                  setAddTaskData({ ...addTaskData, Collaborators: next.join(',') });
                                }}
                              />
                              {c.Text}
                            </label>
                          ))}
                        </div>
                      </div>
                    </Popper>
                  )}
                </div>
              </div>
            </div>

            <div className="task-row-group" style={{ marginTop: '10px', padding: '0 5px' }}>
              <label className="task-checkbox-label" style={{ display: 'flex', alignItems: 'center', gap: '10px', cursor: 'pointer' }}>
                <input
                  type="checkbox"
                  checked={addTaskData.SendNotification}
                  onChange={(e) => setAddTaskData({ ...addTaskData, SendNotification: e.target.checked })}
                  style={{ width: '18px', height: '18px', accentColor: '#3b82f6' }}
                />
                <span style={{ fontSize: '14px', fontWeight: 600, color: '#475569' }}>Send Notification</span>
              </label>
            </div>

            <div className="drawer-footer" style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
              <button className="btn-submit" onClick={handleAddTaskSubmit} disabled={isSubmittingTask} style={{ background: '#4caf50' }}>
                SAVE
              </button>
            </div>
          </div>
        </Panels>


        <Panels
          isOpen={showEditTaskModal}
          onClose={() => setShowEditTaskModal(false)}
          title="Task"
          width="50%"
        >
          <div className="drawer-body">
            <h2 className="drawer-title">Edit Task</h2>
            {isEditLoading ? (
              <div className="flex items-center justify-center p-10"><Loader message="Loading task details..." /></div>
            ) : (
              <>
                <div className="task-form-group">
                  <label className="task-form-label">Title *</label>
                  <input
                    type="text"
                    className="task-form-control"
                    placeholder="Enter Title"
                    value={editTaskData.Title}
                    onChange={(e) => setEditTaskData({ ...editTaskData, Title: e.target.value })}
                  />
                </div>

                <div className="task-form-group">
                  <label className="task-form-label">Description</label>
                  <textarea
                    className="task-form-control"
                    placeholder="Start Typing the details about the task..."
                    value={editTaskData.Description}
                    onChange={(e) => setEditTaskData({ ...editTaskData, Description: e.target.value })}
                    style={{ minHeight: '100px' }}
                  />
                </div>

                <div className="task-row-group">
                  <div className="task-form-group third-width">
                    <label className="task-form-label">Task Type</label>
                    <select
                      className="task-form-control"
                      value={editTaskData.TaskType}
                      onChange={(e) => setEditTaskData({ ...editTaskData, TaskType: e.target.value })}
                    >
                      <option value="">Select Task Type</option>
                      {taskTypeOptions.map(opt => (
                        <option key={opt.TasKId || opt.Id} value={opt.TasKId || opt.Id}>{opt.TasKName}</option>
                      ))}
                    </select>
                  </div>

                  <div className="task-form-group third-width">
                    <label className="task-form-label">Due Date and Time *</label>
                    <div className="premium-datetime-container" onClick={(e) => e.currentTarget.querySelector('input').showPicker()}>
                      <Calendar size={18} className="datetime-icon" />
                      <div className="premium-datetime-value">
                        {formatDateTimeDisplay(editTaskData.DueDate, editTaskData.DueTime)}
                      </div>
                      <input
                        type="datetime-local"
                        value={`${editTaskData.DueDate}T${editTaskData.DueTime}`}
                        min={getLocalISO()}
                        onChange={(e) => handleCombinedDateTimeChange(e, setEditTaskData, 'DueDate', 'DueTime')}
                        className="hidden-datetime-input"
                      />
                    </div>
                  </div>

                  <div className="task-form-group third-width">
                    <label className="task-form-label">Related To</label>
                    <div className="related-input-wrapper" ref={relatedRef}>
                      <div className="related-search-container">
                        {!relatedSelected && (
                          <input
                            type="text"
                            className="task-form-control"
                            placeholder="Type Task name or Mobile or Company"
                            value={relatedSearch}
                            onChange={(e) => {
                              setRelatedSearch(e.target.value);
                              setShowRelatedDropdown(true);
                            }}
                            onFocus={() => {
                              if (relatedSearch.length >= 2) setShowRelatedDropdown(true);
                            }}
                          />
                        )}
                        {relatedSelected && (
                          <div className="selected-lead-internal-chip">
                            <span className="selected-lead-name">
                              {relatedSelected.PersonName || relatedSelected.Name || relatedSelected.RelatedTo || 'Selected'}
                            </span>
                            <button className="remove-lead-btn" onClick={() => setRelatedSelected(null)}>✕</button>
                          </div>
                        )}
                      </div>
                      {showRelatedDropdown && relatedSuggestions.length > 0 && (
                        <Popper
                          open={showRelatedDropdown}
                          anchorEl={relatedRef.current}
                          placement="bottom-start"
                          modifiers={[
                            { name: 'flip', enabled: false },
                            { name: 'preventOverflow', enabled: true, options: { boundary: 'viewport' } }
                          ]}
                          style={{ zIndex: 100001, width: relatedRef.current?.offsetWidth }}
                        >
                          <ul className="related-suggestions-list" style={{ width: '100%', maxHeight: '250px', overflowY: 'auto', background: 'white', border: '1px solid #e2e8f0', borderRadius: '8px', boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1)', marginTop: '4px' }}>
                            {relatedSuggestions.map((s, i) => (
                              <li key={i} onClick={() => {
                                setRelatedSelected(s);
                                setRelatedSearch('');
                                setShowRelatedDropdown(false);
                              }} style={{ padding: '10px 12px', borderBottom: '1px solid #f1f5f9', cursor: 'pointer' }}>
                                <div style={{ fontWeight: '600', color: '#334155' }}>{s.PersonName || s.Name || s.RelatedTo || s.Text || s.text}</div>
                                <div style={{ fontSize: '12px', color: '#64748b' }}>{s.PersonalMobileNo || s.MobileNo || s.CsvMobileNo}</div>
                              </li>
                            ))}
                          </ul>
                        </Popper>
                      )}
                      <small className="related-helper" style={{ fontSize: '10px', color: '#94a3b8' }}>(From Lead Section)</small>
                    </div>
                  </div>
                </div>

                <div className="task-row-group">
                  <div className="task-form-group half-width">
                    <label className="task-form-label">Owner</label>
                    <select
                      className="task-form-control"
                      value={editTaskData.Owner}
                      onChange={(e) => setEditTaskData({ ...editTaskData, Owner: e.target.value })}
                    >
                      {ownerOptions.map(opt => (
                        <option key={opt.Code} value={opt.Code}>{opt.Text}</option>
                      ))}
                    </select>
                  </div>

                  <div className="task-form-group half-width">
                    <label className="task-form-label">Collaborators</label>
                    <div className="collaborator-select-wrapper" ref={collabRef}>
                      <div
                        className="collab-display"
                        onClick={(e) => { e.stopPropagation(); setShowCollabDropdown(prev => !prev); }}
                      >
                        {editTaskData.Collaborators && editTaskData.Collaborators.split(',').filter(x => x).length > 0 ? (
                          editTaskData.Collaborators.split(',').filter(x => x).map(id => {
                            const collab = collaboratorOptions.find(c => String(c.Code) === id);
                            return collab ? (
                              <div key={id} className="collaborator-chip">
                                <span>{collab.Text}</span>
                                <X
                                  size={14}
                                  className="remove-collab"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    const next = editTaskData.Collaborators.split(',').filter(x => x && x !== id);
                                    setEditTaskData({ ...editTaskData, Collaborators: next.join(',') });
                                  }}
                                />
                              </div>
                            ) : null;
                          })
                        ) : (
                          <span className="collab-placeholder">Select Collaborators</span>
                        )}
                        <div style={{ flex: 1 }}></div>
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#94a3b8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ transition: 'transform 0.2s ease', transform: showCollabDropdown ? 'rotate(180deg)' : 'rotate(0deg)', flexShrink: 0 }}><polyline points="6 9 12 15 18 9" /></svg>
                      </div>
                      {showCollabDropdown && (
                        <Popper
                          open={showCollabDropdown}
                          anchorEl={collabRef.current}
                          placement="bottom-start"
                          modifiers={[
                            { name: 'flip', enabled: false },
                            { name: 'preventOverflow', enabled: true, options: { boundary: 'viewport' } }
                          ]}
                          style={{ zIndex: 100001, width: collabRef.current?.offsetWidth }}
                        >
                          <div className="collab-dropdown-menu" onClick={(e) => e.stopPropagation()} style={{ width: '100%' }}>
                            <div className="collab-dropdown-header">
                              <span className="collab-dropdown-title">Collaborators</span>
                              <button
                                className="collab-dropdown-close"
                                onClick={(e) => { e.stopPropagation(); setShowCollabDropdown(false); setCollabSearch(''); }}
                              >
                                <X size={15} />
                              </button>
                            </div>
                            <input
                              type="text"
                              className="collab-search"
                              placeholder="Search..."
                              value={collabSearch}
                              onChange={(e) => setCollabSearch(e.target.value)}
                              onClick={(e) => e.stopPropagation()}
                            />
                            <div className="collab-options-list">
                              {collaboratorOptions.filter(c => (c.Text || '').toLowerCase().includes(collabSearch.toLowerCase())).map(c => (
                                <label key={c.Code} className="collab-option" onClick={(e) => e.stopPropagation()}>
                                  <input
                                    type="checkbox"
                                    checked={editTaskData.Collaborators.split(',').includes(String(c.Code))}
                                    onChange={(e) => {
                                      const current = editTaskData.Collaborators ? editTaskData.Collaborators.split(',').filter(x => x) : [];
                                      let next;
                                      if (e.target.checked) next = [...current, String(c.Code)];
                                      else next = current.filter(id => id !== String(c.Code));
                                      setEditTaskData({ ...editTaskData, Collaborators: next.join(',') });
                                    }}
                                  />
                                  {c.Text}
                                </label>
                              ))}
                            </div>
                          </div>
                        </Popper>
                      )}
                    </div>
                  </div>
                </div>

                <div className="task-row-group" style={{ marginTop: '10px', padding: '0 5px' }}>
                  <label className="task-checkbox-label" style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer' }}>
                    <input
                      type="checkbox"
                      checked={editTaskData.SendNotification}
                      onChange={(e) => setEditTaskData({ ...editTaskData, SendNotification: e.target.checked })}
                      style={{ width: '18px', height: '18px', accentColor: '#3b82f6' }}
                    />
                    <span style={{ fontSize: '14px', fontWeight: 600, color: '#475569' }}>Send Notification</span>
                  </label>
                </div>

                <div className="drawer-footer">
                  <button className="btn-reset-form" onClick={() => initialEditTaskData && setEditTaskData(initialEditTaskData)} style={{ background: 'none', border: 'none', color: '#64748b', fontWeight: '600', cursor: 'pointer', fontSize: '14px' }}>Reset</button>
                  <div style={{ flex: 1 }}></div>
                  <button className="btn-submit" onClick={handleEditTaskSubmit} disabled={isSubmittingTask}>
                    SAVE
                  </button>
                </div>
              </>
            )}
          </div>
        </Panels>


        {/* Unified Mass Operation Drawer */}
        <MassOperationDrawer
          isOpen={showMassDrawer}
          onClose={() => setShowMassDrawer(false)}
          operationMode={activeOperationMode}
          selectedCount={selectedCount}
        />

        {/* Mass Update Panel */}
        <Panels
          isOpen={isMassUpdateActivePanel}
          onClose={() => setIsMassUpdateActivePanel(false)}
          backTitle="Back"
          title="Task"
          width="50%"
        >
          <div className="drawer-body">
            <h2 className="drawer-title">Mass Update</h2>

            <div className="task-form-group">
              <label className="task-form-label">Description</label>
              <textarea
                className="task-form-control"
                rows="3"
                value={massUpdateData.Description}
                onChange={e => setMassUpdateData(prev => ({ ...prev, Description: e.target.value }))}
                placeholder="Start Typing the details about the task."
              />
            </div>

            <div className="task-form-group">
              <label className="task-form-label">Remarks</label>
              <textarea
                className="task-form-control"
                rows="3"
                value={massUpdateData.Remarks}
                onChange={e => setMassUpdateData(prev => ({ ...prev, Remarks: e.target.value }))}
                placeholder="about the task..."
              />
            </div>

            <div className="task-form-group">
              <label className="task-form-label">Sales Activity Type</label>
              <select
                className="task-form-control"
                value={massUpdateData.TaskType}
                onChange={e => setMassUpdateData(prev => ({ ...prev, TaskType: e.target.value }))}
              >
                <option value="">Select Activity Type</option>
                {taskTypeOptions.map(opt => (
                  <option key={opt.TasKId} value={opt.TasKId}>{opt.TasKName}</option>
                ))}
              </select>
            </div>

            <div className="task-form-group">
              <label className="task-form-label">Due Date and Time *</label>
              <div className="premium-datetime-container" onClick={(e) => e.currentTarget.querySelector('input').showPicker()}>
                <Calendar size={18} className="datetime-icon" />
                <div className="premium-datetime-value">
                  {massUpdateData.DueDateTime ? formatDateTimeDisplay(massUpdateData.DueDateTime.split('T')[0], massUpdateData.DueDateTime.split('T')[1]) : "--"}
                </div>
                <input
                  type="datetime-local"
                  value={massUpdateData.DueDateTime}
                  onChange={e => setMassUpdateData(prev => ({ ...prev, DueDateTime: e.target.value }))}
                  className="hidden-datetime-input"
                />
              </div>
            </div>

            <div className="task-form-group">
              <label className="task-form-label">Owner</label>
              <select
                className="task-form-control"
                value={massUpdateData.Owner}
                onChange={e => setMassUpdateData(prev => ({ ...prev, Owner: e.target.value }))}
              >
                <option value="">Nothing selected</option>
                {ownerOptions.map(o => <option key={o.Code} value={o.Code}>{o.Text}</option>)}
              </select>
            </div>

            <div className="task-form-group" ref={massCollabRef} style={{ marginTop: '20px' }}>
              <label className="task-form-label">Collaborators</label>
              <div
                onClick={(e) => { e.stopPropagation(); setMassCollabDropdownOpen(prev => !prev); }}
                className="collab-display"
              >
                {massSelectedCollabs.length === 0 ? <span className="collab-placeholder">Nothing selected</span> : massSelectedCollabs.map(c => (
                  <div key={c.id} className="collaborator-chip">
                    <span>{c.name}</span>
                    <X
                      size={14}
                      className="remove-collab"
                      onClick={(e) => {
                        e.stopPropagation();
                        setMassSelectedCollabs(prev => prev.filter(x => x.id !== c.id));
                      }}
                    />
                  </div>
                ))}
                <div style={{ flex: 1 }}></div>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#94a3b8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ transition: 'transform 0.2s ease', transform: massCollabDropdownOpen ? 'rotate(180deg)' : 'rotate(0deg)', flexShrink: 0 }}><polyline points="6 9 12 15 18 9" /></svg>
              </div>
              {massCollabDropdownOpen && (
                <Popper
                  open={massCollabDropdownOpen}
                  anchorEl={massCollabRef.current}
                  placement="bottom-start"
                  modifiers={[
                    { name: 'flip', enabled: false },
                    { name: 'preventOverflow', enabled: true, options: { boundary: 'viewport' } }
                  ]}
                  style={{ zIndex: 100001, width: massCollabRef.current?.offsetWidth }}
                >
                  <div className="collab-dropdown-menu" onClick={(e) => e.stopPropagation()} style={{ width: '100%' }}>
                    <div className="collab-dropdown-header">
                      <span className="collab-dropdown-title">Collaborators</span>
                      <button
                        className="collab-dropdown-close"
                        onClick={(e) => { e.stopPropagation(); setMassCollabDropdownOpen(false); setMassCollabSearch(''); }}
                      >
                        <X size={15} />
                      </button>
                    </div>
                    <input
                      type="text"
                      placeholder="Search..."
                      className="collab-search"
                      value={massCollabSearch}
                      onChange={e => setMassCollabSearch(e.target.value)}
                      onClick={e => e.stopPropagation()}
                    />
                    <div className="collab-options-list">
                      {collaboratorOptions.filter(o => o.Text.toLowerCase().includes(massCollabSearch.toLowerCase())).map(o => (
                        <label key={o.Code} className="collab-option" onClick={(e) => e.stopPropagation()}>
                          <input
                            type="checkbox"
                            checked={massSelectedCollabs.some(c => String(c.id) === String(o.Code))}
                            onChange={() => {
                              const codeStr = String(o.Code);
                              if (massSelectedCollabs.some(c => String(c.id) === codeStr)) {
                                setMassSelectedCollabs(prev => prev.filter(c => String(c.id) !== codeStr));
                              } else {
                                setMassSelectedCollabs(prev => [...prev, { id: codeStr, name: o.Text }]);
                              }
                            }}
                          />
                          {o.Text}
                        </label>
                      ))}
                    </div>
                  </div>
                </Popper>
              )}
            </div>

            <div style={{ marginTop: '10px', padding: '0 5px' }}>
              <label className="task-checkbox-label" style={{ display: 'flex', alignItems: 'center', gap: '10px', cursor: 'pointer' }}>
                <input
                  type="checkbox"
                  checked={massUpdateData.MarkAsCompleted}
                  onChange={e => setMassUpdateData(prev => ({ ...prev, MarkAsCompleted: e.target.checked }))}
                  style={{ width: '18px', height: '18px', accentColor: '#3b82f6' }}
                />
                <span style={{ fontSize: '14px', fontWeight: 600, color: '#475569' }}>Mark as Completed</span>
              </label>
            </div>

            <div className="drawer-footer" style={{ padding: '24px 0 0 0', display: 'flex', justifyContent: 'flex-end' }}>
              <button disabled={massSubmitting} onClick={async () => {
                setMassSubmitting(true);
                try {
                  const uid = localStorage.getItem('userId') || '34594';
                  const token = localStorage.getItem('token') || '-2295521862261168';
                  const collabIds = massSelectedCollabs.map(c => c.id).join(',');
                  const idsStr = isAllSelectedAcrossPages ? allIds.join(',') : Object.keys(rowSelection).filter(k => rowSelection[k]).join(',');

                  const d = new Date(massUpdateData.DueDateTime);
                  const formattedDate = d.toISOString().slice(0, 10) + ' ' + d.toTimeString().slice(0, 8);

                  const selectedTaskType = taskTypeOptions.find(opt => String(opt.TasKId || opt.Id) === massUpdateData.TaskType);
                  const taskTypeName = selectedTaskType ? selectedTaskType.TasKName : "";

                  const payload = {
                    Token: token || "-2295521862261168",
                    Details: {
                      strUserID: uid,
                      strParentID: uid,
                      strTimezone: "Asia/Kolkata",
                      massInsertUpdateTaskaAppointment: {
                        LeadIds: "",
                        Ids: idsStr,
                        Title: "Mass Update",
                        Description: massUpdateData.Description,
                        Remarks: massUpdateData.Remarks,
                        Address: "",
                        StartDate: formattedDate,
                        EndDate: formattedDate,
                        AssignedTo: parseInt(massUpdateData.Owner || uid),
                        IsActive: true,
                        TaskId: 0,
                        Status: massUpdateData.MarkAsCompleted ? "Completed" : "Pending",
                        CreatedBy: parseInt(uid),
                        OutcomesId: 0,
                        CollabratoerUserIds: collabIds,
                        IsSMS: false,
                        IsEmail: false,
                        IsTask: true,
                        IsAppointment: false,
                        TaskType: taskTypeName,
                        CompleteAddress: "",
                        Latitude: "",
                        Longitude: "",
                        SmsSchedule: "",
                        EmailSchedule: "",
                        NotifyMe: false,
                        Batchid: 0,
                        scheduledatetime: formattedDate,
                        emMessageId: "",
                        emAttachmentId: "",
                        DLTTemplateIDForSMSReminder: "",
                        DLTTemplateIDForNotify: ""
                      }
                    }
                  };

                  const response = await fetch(Mass_Update, {
                    method: 'POST',
                    headers: {
                      'Content-Type': 'application/json; charset=UTF-8',
                      'X-Requested-With': 'XMLHttpRequest'
                    },
                    body: JSON.stringify(payload)
                  });

                  if (response.ok) {
                    setIsMassUpdateActivePanel(false);
                    setRowSelection({});
                    setMassOperation('');
                    setAlertConfig({
                      show: true,
                      type: 'success',
                      title: 'Success',
                      message: 'Tasks Updated Successfully',
                      onConfirm: () => {
                        setAlertConfig({ ...alertConfig, show: false });
                        window.location.reload();
                      }
                    });
                  } else {
                    setAlertConfig({
                      show: true,
                      type: 'error',
                      title: 'Error',
                      message: 'Mass update failed. Please try again.',
                      onConfirm: () => setAlertConfig({ ...alertConfig, show: false })
                    });
                  }
                } catch (e) {
                  console.error('Mass update error:', e);
                  setAlertConfig({
                    show: true,
                    type: 'error',
                    title: 'Error',
                    message: 'An error occurred during mass update.',
                    onConfirm: () => setAlertConfig({ ...alertConfig, show: false })
                  });
                } finally {
                  setMassSubmitting(false);
                }
              }} style={{ padding: '9px 28px', border: 'none', background: '#0d6efd', color: '#fff', borderRadius: '4px', cursor: 'pointer', fontWeight: '700', fontSize: '14px' }}>
                {massSubmitting ? 'Updating...' : 'Update'}
              </button>
            </div>
          </div>
        </Panels>


        {/* Add Outcome Modal */}
        <Dialog
          open={showOutcomeModal}
          onClose={() => setShowOutcomeModal(false)}
          maxWidth="sm"
          fullWidth
          PaperProps={{
            sx: { borderRadius: '12px' }
          }}
        >
          <DialogTitle sx={{ borderBottom: '1px solid #f1f5f9', pb: 2 }}>
            <Box display="flex" justifyContent="space-between" alignItems="center">
              <Typography variant="h6" fontWeight="600" color="#334155">Add Outcome</Typography>
              <Box onClick={() => setShowOutcomeModal(false)} sx={{ cursor: 'pointer', color: '#64748b', '&:hover': { color: '#334155' } }}>&times;</Box>
            </Box>
          </DialogTitle>
          <DialogContent sx={{ pt: 3 }}>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3, mt: 1 }}>
              <FormControl fullWidth>
                <InputLabel sx={{ color: '#64748b', mb: 1, position: 'relative', transform: 'none', fontSize: '14px', fontWeight: '500' }}>Outcome</InputLabel>
                <Select
                  value={outcomeData.outcomeId}
                  onChange={(e) => setOutcomeData(prev => ({ ...prev, outcomeId: e.target.value }))}
                  displayEmpty
                  sx={{ borderRadius: '8px', backgroundColor: '#fff', '& .MuiOutlinedInput-notchedOutline': { borderColor: '#e2e8f0' } }}
                >
                  <MenuItem value="" disabled>Select Outcome</MenuItem>
                  {outcomeOptions.map(option => (
                    <MenuItem key={option.Id} value={option.Id}>{option.Text}</MenuItem>
                  ))}
                </Select>
              </FormControl>

              <Box>
                <Typography component="label" sx={{ display: 'block', fontSize: '14px', fontWeight: '500', color: '#64748b', mb: 1 }}>Remarks</Typography>
                <TextField
                  fullWidth
                  multiline
                  rows={3}
                  value={outcomeData.remarks}
                  onChange={(e) => setOutcomeData(prev => ({ ...prev, remarks: e.target.value }))}
                  placeholder="Enter remarks..."
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      borderRadius: '8px',
                      backgroundColor: '#fff',
                      '& fieldset': { borderColor: '#e2e8f0' }
                    }
                  }}
                />
              </Box>
            </Box>
          </DialogContent>
          <DialogActions sx={{ p: 3, borderTop: '1px solid #f1f5f9', gap: 1 }}>
            <Button
              onClick={() => setShowOutcomeModal(false)}
              sx={{
                borderRadius: '8px', px: 3, textTransform: 'none', fontWeight: '600',
                color: '#fff', backgroundColor: '#14b8a6', '&:hover': { backgroundColor: '#0f766e' }
              }}
            >
              Close
            </Button>
            <Button
              variant="contained"
              onClick={handleSaveOutcome}
              disabled={isSubmittingTask}
              sx={{
                borderRadius: '8px', px: 3, textTransform: 'none', fontWeight: '600',
                backgroundColor: '#22c55e', '&:hover': { backgroundColor: '#16a34a' }
              }}
            >
              {isSubmittingTask ? 'Saving...' : 'Save'}
            </Button>
          </DialogActions>
        </Dialog>

        {/* Add Comment Modal */}
        <Dialog
          open={showCommentModal}
          onClose={() => setShowCommentModal(false)}
          maxWidth="sm"
          fullWidth
          PaperProps={{
            sx: { borderRadius: '12px', p: 1 }
          }}
        >
          <DialogTitle sx={{ borderBottom: '1px solid #f1f5f9', pb: 2 }}>
            <Box display="flex" justifyContent="space-between" alignItems="center">
              <Typography variant="h6" fontWeight="600" color="#334155">Add Comment</Typography>
              <Box onClick={() => setShowCommentModal(false)} sx={{ cursor: 'pointer', color: '#64748b', '&:hover': { color: '#334155' }, fontSize: '20px' }}>✕</Box>
            </Box>
          </DialogTitle>
          <DialogContent sx={{ pt: 3 }}>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2.5 }}>
              <Box>
                <Typography component="label" sx={{ display: 'block', fontSize: '14px', fontWeight: '500', color: '#334155', mb: 1 }}>Comment</Typography>
                <TextField
                  fullWidth
                  multiline
                  rows={3}
                  value={commentText}
                  onChange={(e) => setCommentText(e.target.value)}
                  placeholder="Please comment here"
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      borderRadius: '8px',
                      backgroundColor: '#fff',
                      '& fieldset': { borderColor: '#e2e8f0' }
                    }
                  }}
                />
              </Box>

              <Box>
                <Typography component="label" sx={{ display: 'block', fontSize: '14px', fontWeight: '500', color: '#334155', mb: 1 }}>Attachment Title</Typography>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                  <input
                    type="file"
                    id="comment-file-input"
                    hidden
                    onChange={handleFileChange}
                  />
                  <Button
                    variant="contained"
                    component="label"
                    htmlFor="comment-file-input"
                    sx={{
                      backgroundColor: '#22c55e',
                      '&:hover': { backgroundColor: '#16a34a' },
                      textTransform: 'none',
                      borderRadius: '6px',
                      width: 'fit-content',
                      px: 2,
                      py: 0.5,
                      fontSize: '13px',
                      boxShadow: 'none'
                    }}
                  >
                    Browse...
                  </Button>
                  <TextField
                    fullWidth
                    size="small"
                    value={commentFileName}
                    InputProps={{
                      readOnly: true,
                    }}
                    placeholder=""
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        borderRadius: '8px',
                        backgroundColor: '#fff',
                        '& fieldset': { borderColor: '#e2e8f0' }
                      }
                    }}
                  />
                </Box>
              </Box>
            </Box>
          </DialogContent>
          <Box sx={{ p: 1.5, borderTop: '1px solid #f1f5f9', mb: 2 }} />
          <DialogActions sx={{ p: 3, pt: 0, justifyContent: 'flex-end', gap: 1.5 }}>
            <Button
              onClick={() => setShowCommentModal(false)}
              sx={{
                borderRadius: '8px', px: 4, py: 1, textTransform: 'none', fontWeight: '600',
                color: '#fff', backgroundColor: '#14b8a6', '&:hover': { backgroundColor: '#0f766e' }
              }}
            >
              Close
            </Button>
            <Button
              variant="contained"
              onClick={handleSaveComment}
              disabled={isSavingComment}
              sx={{
                borderRadius: '8px', px: 4, py: 1, textTransform: 'none', fontWeight: '600',
                backgroundColor: '#22c55e', '&:hover': { backgroundColor: '#16a34a' },
                boxShadow: 'none'
              }}
            >
              {isSavingComment ? 'Saving...' : 'Save'}
            </Button>
          </DialogActions>
        </Dialog>



        {/* Render EntityEdit Modal */}
        {editingEntityInTask && (
          <EntityEdit
            entityData={editingEntityInTask}
            onSave={() => {
              fetchTasks();
              setEditingEntityInTask(null);
            }}
            onCancel={() => setEditingEntityInTask(null)}
          />
        )}

      </div>
      {/* Custom Alert Component */}
      <Alert
        show={alertConfig.show}
        type={alertConfig.type}
        title={alertConfig.title}
        message={alertConfig.message}
        onConfirm={alertConfig.onConfirm}
        onCancel={() => setAlertConfig({ ...alertConfig, show: false })}
      />
    </div>
  );
};

export default TaskModule;
